// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AdminAnnouncementServiceAdminCreateAnnouncementData, AdminAnnouncementServiceAdminCreateAnnouncementResponses, AdminAnnouncementServiceAdminCreateAnnouncementTemplateData, AdminAnnouncementServiceAdminCreateAnnouncementTemplateResponses, AdminAnnouncementServiceAdminDeleteAnnouncementTemplateData, AdminAnnouncementServiceAdminDeleteAnnouncementTemplateResponses, AdminAnnouncementServiceAdminListAnnouncementsData, AdminAnnouncementServiceAdminListAnnouncementsResponses, AdminAnnouncementServiceAdminListAnnouncementTemplatesData, AdminAnnouncementServiceAdminListAnnouncementTemplatesResponses, AdminAnnouncementServiceAdminRenderAnnouncementTemplateData, AdminAnnouncementServiceAdminRenderAnnouncementTemplateResponses, AdminAnnouncementServiceAdminSetAnnouncementPublishedData, AdminAnnouncementServiceAdminSetAnnouncementPublishedResponses, AdminAnnouncementServiceAdminUpdateAnnouncementData, AdminAnnouncementServiceAdminUpdateAnnouncementResponses, AdminAnnouncementServiceAdminUpdateAnnouncementTemplateData, AdminAnnouncementServiceAdminUpdateAnnouncementTemplateResponses, AdminAppServiceGetAppData, AdminAppServiceGetAppResponses, AdminAppServiceListApiKeysData, AdminAppServiceListApiKeysResponses, AdminAppServiceListAppsData, AdminAppServiceListAppsResponses, AdminAuthenticationServiceGetStatusData, AdminAuthenticationServiceGetStatusResponses, AdminAuthenticationServiceGetUserStateData, AdminAuthenticationServiceGetUserStateResponses, AdminAuthenticationServiceListAuditData, AdminAuthenticationServiceListAuditResponses, AdminAuthenticationServiceListOperationsData, AdminAuthenticationServiceListOperationsResponses, AdminAuthenticationServiceReconcileUserData, AdminAuthenticationServiceReconcileUserResponses, AdminAuthenticationServiceRetryOperationData, AdminAuthenticationServiceRetryOperationResponses, AdminAuthServiceChangePasswordData, AdminAuthServiceChangePasswordResponses, AdminAuthServiceLoginData, AdminAuthServiceLoginResponses, AdminAvatarApplyServiceAdminDeleteAvatarApplyData, AdminAvatarApplyServiceAdminDeleteAvatarApplyResponses, AdminAvatarApplyServiceAdminListAvatarAppliesData, AdminAvatarApplyServiceAdminListAvatarAppliesResponses, AdminAvatarUnitServiceCreateAvatarPipelineData, AdminAvatarUnitServiceCreateAvatarPipelineResponses, AdminAvatarUnitServiceCreateAvatarUnitPackageData, AdminAvatarUnitServiceCreateAvatarUnitPackageResponses, AdminAvatarUnitServiceDeleteAvatarPipelineData, AdminAvatarUnitServiceDeleteAvatarPipelineResponses, AdminAvatarUnitServiceDeleteAvatarUnitPackageData, AdminAvatarUnitServiceDeleteAvatarUnitPackageResponses, AdminAvatarUnitServiceGetUserAvatarUnitBalanceData, AdminAvatarUnitServiceGetUserAvatarUnitBalanceResponses, AdminAvatarUnitServiceGrantAvatarUnitsData, AdminAvatarUnitServiceGrantAvatarUnitsResponses, AdminAvatarUnitServiceListAvatarPipelinesData, AdminAvatarUnitServiceListAvatarPipelinesResponses, AdminAvatarUnitServiceListAvatarUnitGrantsData, AdminAvatarUnitServiceListAvatarUnitGrantsResponses, AdminAvatarUnitServiceListAvatarUnitPackagesData, AdminAvatarUnitServiceListAvatarUnitPackagesResponses, AdminAvatarUnitServiceListAvatarUnitTransactionsData, AdminAvatarUnitServiceListAvatarUnitTransactionsResponses, AdminAvatarUnitServiceUpdateAvatarPipelineData, AdminAvatarUnitServiceUpdateAvatarPipelineResponses, AdminAvatarUnitServiceUpdateAvatarUnitPackageData, AdminAvatarUnitServiceUpdateAvatarUnitPackageResponses, AdminBillingServiceCreateCreditPackageData, AdminBillingServiceCreateCreditPackageResponses, AdminBillingServiceCreatePlanData, AdminBillingServiceCreatePlanResponses, AdminBillingServiceDeductCreditsData, AdminBillingServiceDeductCreditsResponses, AdminBillingServiceDeleteCreditPackageData, AdminBillingServiceDeleteCreditPackageResponses, AdminBillingServiceDeletePlanData, AdminBillingServiceDeletePlanResponses, AdminBillingServiceGetBillingStatsData, AdminBillingServiceGetBillingStatsResponses, AdminBillingServiceGetPlanData, AdminBillingServiceGetPlanResponses, AdminBillingServiceGetUserCreditBalanceData, AdminBillingServiceGetUserCreditBalanceResponses, AdminBillingServiceGetUserSubscriptionData, AdminBillingServiceGetUserSubscriptionResponses, AdminBillingServiceGrantCreditsData, AdminBillingServiceGrantCreditsResponses, AdminBillingServiceListCreditPackagesData, AdminBillingServiceListCreditPackagesResponses, AdminBillingServiceListCreditTransactionsData, AdminBillingServiceListCreditTransactionsResponses, AdminBillingServiceListPlansData, AdminBillingServiceListPlansResponses, AdminBillingServiceListSubscriptionsData, AdminBillingServiceListSubscriptionsResponses, AdminBillingServiceListUserCreditTransactionsData, AdminBillingServiceListUserCreditTransactionsResponses, AdminBillingServiceListUserCreditUsagesData, AdminBillingServiceListUserCreditUsagesResponses, AdminBillingServiceUpdateCreditPackageData, AdminBillingServiceUpdateCreditPackageResponses, AdminBillingServiceUpdatePlanData, AdminBillingServiceUpdatePlanResponses, AdminBillingServiceUpdateUserSubscriptionData, AdminBillingServiceUpdateUserSubscriptionResponses, AdminChatServiceAdminCloseChatData, AdminChatServiceAdminCloseChatResponses, AdminChatServiceAdminCreateChatData, AdminChatServiceAdminCreateChatResponses, AdminChatServiceAdminGetChatData, AdminChatServiceAdminGetChatResponses, AdminChatServiceAdminListChatsData, AdminChatServiceAdminListChatsResponses, AdminChatServiceAdminMarkChatReadData, AdminChatServiceAdminMarkChatReadResponses, AdminChatServiceAdminSendChatMessageData, AdminChatServiceAdminSendChatMessageResponses, AdminConfigServiceAdminAddAvatarQuotaData, AdminConfigServiceAdminAddAvatarQuotaResponses, AdminConfigServiceAdminCreateConfigData, AdminConfigServiceAdminCreateConfigResponses, AdminConfigServiceAdminCreateUserConfigData, AdminConfigServiceAdminCreateUserConfigResponses, AdminConfigServiceAdminDeleteConfigData, AdminConfigServiceAdminDeleteConfigResponses, AdminConfigServiceAdminGetConfigData, AdminConfigServiceAdminGetConfigResponses, AdminConfigServiceAdminGetUserConfigData, AdminConfigServiceAdminGetUserConfigResponses, AdminConfigServiceAdminListConfigsData, AdminConfigServiceAdminListConfigsResponses, AdminConfigServiceAdminListUserConfigsData, AdminConfigServiceAdminListUserConfigsResponses, AdminConfigServiceAdminUpdateConfigData, AdminConfigServiceAdminUpdateConfigResponses, AdminConfigServiceAdminUpdateUserConfigData, AdminConfigServiceAdminUpdateUserConfigResponses, AdminConsoleAvatarListServiceCreateConsoleAvatarListData, AdminConsoleAvatarListServiceCreateConsoleAvatarListResponses, AdminConsoleAvatarListServiceDeleteConsoleAvatarListData, AdminConsoleAvatarListServiceDeleteConsoleAvatarListResponses, AdminConsoleAvatarListServiceGetConsoleAvatarListData, AdminConsoleAvatarListServiceGetConsoleAvatarListResponses, AdminConsoleAvatarListServiceListConsoleAvatarListsData, AdminConsoleAvatarListServiceListConsoleAvatarListsResponses, AdminConsoleAvatarListServiceUpdateConsoleAvatarListData, AdminConsoleAvatarListServiceUpdateConsoleAvatarListResponses, AdminDrivenIngressAvatarAccessServiceCreateUserData, AdminDrivenIngressAvatarAccessServiceCreateUserResponses, AdminDrivenIngressAvatarAccessServiceDeleteUserData, AdminDrivenIngressAvatarAccessServiceDeleteUserResponses, AdminDrivenIngressAvatarAccessServiceListUsersData, AdminDrivenIngressAvatarAccessServiceListUsersResponses, AdminDrivenIngressAvatarAccessServiceUpdateUserData, AdminDrivenIngressAvatarAccessServiceUpdateUserResponses, AdminDrivenStatsServiceGetConcurrencyTrendData, AdminDrivenStatsServiceGetConcurrencyTrendResponses, AdminDrivenStatsServiceGetEntityStatsData, AdminDrivenStatsServiceGetEntityStatsResponses, AdminDrivenStatsServiceGetOverviewData, AdminDrivenStatsServiceGetOverviewResponses, AdminDrivenStatsServiceGetRealtimeStatsData, AdminDrivenStatsServiceGetRealtimeStatsResponses, AdminDrivenStatsServiceGetRegionDistributionData, AdminDrivenStatsServiceGetRegionDistributionResponses, AdminDrivenStatsServiceGetTopUsersData, AdminDrivenStatsServiceGetTopUsersResponses, AdminDrivenStatsServiceGetTrendData, AdminDrivenStatsServiceGetTrendResponses, AdminDrivenStatsServiceListConnectionLogsData, AdminDrivenStatsServiceListConnectionLogsResponses, AdminEmailServiceAdminCreateEmailCategoryData, AdminEmailServiceAdminCreateEmailCategoryResponses, AdminEmailServiceAdminCreateEmailTemplateData, AdminEmailServiceAdminCreateEmailTemplateResponses, AdminEmailServiceAdminDeleteEmailCategoryData, AdminEmailServiceAdminDeleteEmailCategoryResponses, AdminEmailServiceAdminDeleteEmailTemplateData, AdminEmailServiceAdminDeleteEmailTemplateResponses, AdminEmailServiceAdminListEmailCategoriesData, AdminEmailServiceAdminListEmailCategoriesResponses, AdminEmailServiceAdminListEmailCategoryUsagesData, AdminEmailServiceAdminListEmailCategoryUsagesResponses, AdminEmailServiceAdminListEmailTemplatesData, AdminEmailServiceAdminListEmailTemplatesResponses, AdminEmailServiceAdminListEmailTemplateUsagesData, AdminEmailServiceAdminListEmailTemplateUsagesResponses, AdminEmailServiceAdminRenderEmailTemplateData, AdminEmailServiceAdminRenderEmailTemplateResponses, AdminEmailServiceAdminSendTestEmailData, AdminEmailServiceAdminSendTestEmailResponses, AdminEmailServiceAdminUpdateEmailCategoryData, AdminEmailServiceAdminUpdateEmailCategoryResponses, AdminEmailServiceAdminUpdateEmailTemplateData, AdminEmailServiceAdminUpdateEmailTemplateResponses, AdminIframeVersionServiceAdminCreateIframeVersionData, AdminIframeVersionServiceAdminCreateIframeVersionResponses, AdminIframeVersionServiceAdminDeleteIframeVersionData, AdminIframeVersionServiceAdminDeleteIframeVersionResponses, AdminIframeVersionServiceAdminGetIframeVersionData, AdminIframeVersionServiceAdminGetIframeVersionResponses, AdminIframeVersionServiceAdminListIframeVersionsData, AdminIframeVersionServiceAdminListIframeVersionsResponses, AdminIframeVersionServiceAdminUpdateIframeVersionData, AdminIframeVersionServiceAdminUpdateIframeVersionResponses, AdminNotificationServiceAdminCreateNotificationRuleData, AdminNotificationServiceAdminCreateNotificationRuleResponses, AdminNotificationServiceAdminCreateNotificationTemplateData, AdminNotificationServiceAdminCreateNotificationTemplateResponses, AdminNotificationServiceAdminDeleteNotificationRuleData, AdminNotificationServiceAdminDeleteNotificationRuleResponses, AdminNotificationServiceAdminDeleteNotificationTemplateData, AdminNotificationServiceAdminDeleteNotificationTemplateResponses, AdminNotificationServiceAdminListNotificationRuleFieldsData, AdminNotificationServiceAdminListNotificationRuleFieldsResponses, AdminNotificationServiceAdminListNotificationRulesData, AdminNotificationServiceAdminListNotificationRulesResponses, AdminNotificationServiceAdminListNotificationsData, AdminNotificationServiceAdminListNotificationsResponses, AdminNotificationServiceAdminListNotificationTemplatesData, AdminNotificationServiceAdminListNotificationTemplatesResponses, AdminNotificationServiceAdminListNotificationTemplateUsagesData, AdminNotificationServiceAdminListNotificationTemplateUsagesResponses, AdminNotificationServiceAdminPreviewNotificationRuleData, AdminNotificationServiceAdminPreviewNotificationRuleResponses, AdminNotificationServiceAdminRenderNotificationTemplateData, AdminNotificationServiceAdminRenderNotificationTemplateResponses, AdminNotificationServiceAdminSetNotificationRuleEnabledData, AdminNotificationServiceAdminSetNotificationRuleEnabledResponses, AdminNotificationServiceAdminUpdateNotificationRuleData, AdminNotificationServiceAdminUpdateNotificationRuleResponses, AdminNotificationServiceAdminUpdateNotificationTemplateData, AdminNotificationServiceAdminUpdateNotificationTemplateResponses, AdminOpenApiPolicyServiceCreateOpenApiPolicyData, AdminOpenApiPolicyServiceCreateOpenApiPolicyResponses, AdminOpenApiPolicyServiceDeleteOpenApiPolicyData, AdminOpenApiPolicyServiceDeleteOpenApiPolicyResponses, AdminOpenApiPolicyServiceGetOpenApiHardLimitsData, AdminOpenApiPolicyServiceGetOpenApiHardLimitsResponses, AdminOpenApiPolicyServiceGetOpenApiPolicyData, AdminOpenApiPolicyServiceGetOpenApiPolicyResponses, AdminOpenApiPolicyServiceListOpenApiPoliciesData, AdminOpenApiPolicyServiceListOpenApiPoliciesResponses, AdminOpenApiPolicyServiceUpdateOpenApiPolicyData, AdminOpenApiPolicyServiceUpdateOpenApiPolicyResponses, AdminStudioAvatarServiceDisconnectStudioConsoleAvatarUserData, AdminStudioAvatarServiceDisconnectStudioConsoleAvatarUserResponses, AdminStudioAvatarServiceListStudioConsoleAvatarsData, AdminStudioAvatarServiceListStudioConsoleAvatarsResponses, AdminStudioAvatarServiceUpdateStudioConsoleAvatarListsData, AdminStudioAvatarServiceUpdateStudioConsoleAvatarListsResponses, AdminStudioAvatarServiceUpdateStudioConsoleAvatarTenantData, AdminStudioAvatarServiceUpdateStudioConsoleAvatarTenantResponses, AdminStudioAvatarServiceUpdateStudioConsoleAvatarUserData, AdminStudioAvatarServiceUpdateStudioConsoleAvatarUserResponses, AdminStudioVoiceAgentProviderServiceAdminCreateStudioVoiceAgentProviderData, AdminStudioVoiceAgentProviderServiceAdminCreateStudioVoiceAgentProviderResponses, AdminStudioVoiceAgentProviderServiceAdminDeleteStudioVoiceAgentProviderData, AdminStudioVoiceAgentProviderServiceAdminDeleteStudioVoiceAgentProviderResponses, AdminStudioVoiceAgentProviderServiceAdminGetStudioVoiceAgentConfigData, AdminStudioVoiceAgentProviderServiceAdminGetStudioVoiceAgentConfigResponses, AdminStudioVoiceAgentProviderServiceAdminGetStudioVoiceAgentProviderData, AdminStudioVoiceAgentProviderServiceAdminGetStudioVoiceAgentProviderResponses, AdminStudioVoiceAgentProviderServiceAdminListStudioVoiceAgentProvidersData, AdminStudioVoiceAgentProviderServiceAdminListStudioVoiceAgentProvidersResponses, AdminStudioVoiceAgentProviderServiceAdminUpdateStudioVoiceAgentConfigData, AdminStudioVoiceAgentProviderServiceAdminUpdateStudioVoiceAgentConfigResponses, AdminStudioVoiceAgentProviderServiceAdminUpdateStudioVoiceAgentProviderData, AdminStudioVoiceAgentProviderServiceAdminUpdateStudioVoiceAgentProviderResponses, AdminUserCharacterServiceAdminCreateUserCharacterData, AdminUserCharacterServiceAdminCreateUserCharacterResponses, AdminUserCharacterServiceAdminDeleteUserCharacterData, AdminUserCharacterServiceAdminDeleteUserCharacterResponses, AdminUserCharacterServiceAdminGetUserCharacterData, AdminUserCharacterServiceAdminGetUserCharacterResponses, AdminUserCharacterServiceAdminListUserCharactersData, AdminUserCharacterServiceAdminListUserCharactersResponses, AdminUserCharacterServiceAdminUpdateUserCharacterData, AdminUserCharacterServiceAdminUpdateUserCharacterResponses, AdminUserServiceCreateAdminUserData, AdminUserServiceCreateAdminUserResponses, AdminUserServiceDeleteAdminUserData, AdminUserServiceDeleteAdminUserResponses, AdminUserServiceListAdminUsersData, AdminUserServiceListAdminUsersResponses, AdminUserServiceListUsersData, AdminUserServiceListUsersResponses, AdminUserServiceUpdateUserRemarkData, AdminUserServiceUpdateUserRemarkResponses, AdminVendorServiceAttachCustomerData, AdminVendorServiceAttachCustomerResponses, AdminVendorServiceCreateVendorData, AdminVendorServiceCreateVendorResponses, AdminVendorServiceListAdministratorsData, AdminVendorServiceListAdministratorsResponses, AdminVendorServiceListCustomersData, AdminVendorServiceListCustomersResponses, AdminVendorServiceListInvitationsData, AdminVendorServiceListInvitationsResponses, AdminVendorServiceListVendorsData, AdminVendorServiceListVendorsResponses, AdminVendorServiceProvisionAdministratorData, AdminVendorServiceProvisionAdministratorResponses, AdminVendorServiceRevokeAdministratorData, AdminVendorServiceRevokeAdministratorResponses, AdminVendorServiceUnlinkCustomerData, AdminVendorServiceUnlinkCustomerResponses, AdminVendorServiceUpdateVendorData, AdminVendorServiceUpdateVendorResponses, AnnouncementServiceListAnnouncementsData, AnnouncementServiceListAnnouncementsResponses, AnnouncementServiceSetAnnouncementReadData, AnnouncementServiceSetAnnouncementReadResponses, AppServiceCreateApiKeyData, AppServiceCreateApiKeyResponses, AppServiceCreateAppData, AppServiceCreateAppResponses, AppServiceDeleteApiKeyData, AppServiceDeleteApiKeyResponses, AppServiceDeleteAppData, AppServiceDeleteAppResponses, AppServiceGetAppData, AppServiceGetAppResponses, AppServiceListApiKeysData, AppServiceListApiKeysResponses, AppServiceListAppsData, AppServiceListAppsResponses, AssetGroupServiceCreateAssetGroupData, AssetGroupServiceCreateAssetGroupFromRawBytesData, AssetGroupServiceCreateAssetGroupFromRawBytesResponses, AssetGroupServiceCreateAssetGroupFromZipData, AssetGroupServiceCreateAssetGroupFromZipResponses, AssetGroupServiceCreateAssetGroupResponses, AssetGroupServiceCreateAvatarModelProfileData, AssetGroupServiceCreateAvatarModelProfileResponses, AssetGroupServiceCreateGenericAssetGroupData, AssetGroupServiceCreateGenericAssetGroupResponses, AssetGroupServiceDeleteAssetGroupData, AssetGroupServiceDeleteAssetGroupResponses, AssetGroupServiceDeprecateAvatarModelProfileData, AssetGroupServiceDeprecateAvatarModelProfileResponses, AssetGroupServiceGetAssetGroupData, AssetGroupServiceGetAssetGroupResponses, AssetGroupServiceGetAssetGroupsByIdsData, AssetGroupServiceGetAssetGroupsByIdsResponses, AssetGroupServiceGetAvatarModelProfileData, AssetGroupServiceGetAvatarModelProfileResponses, AssetGroupServiceGetGenericAssetGroupData, AssetGroupServiceGetGenericAssetGroupResponses, AssetGroupServiceListAssetGroupsData, AssetGroupServiceListAssetGroupsResponses, AssetGroupServiceListAvatarModelProfilesData, AssetGroupServiceListAvatarModelProfilesResponses, AssetGroupServiceReplaceAssetGroupAssetData, AssetGroupServiceReplaceAssetGroupAssetResponses, AssetGroupServiceUpdateAssetGroupData, AssetGroupServiceUpdateAssetGroupResponses, AssetGroupServiceUpdateAvatarModelProfileData, AssetGroupServiceUpdateAvatarModelProfileResponses, AsyncProcessingServiceAdjustMaterialAsyncData, AsyncProcessingServiceAdjustMaterialAsyncResponses, AsyncProcessingServiceCreateTaskAsyncData, AsyncProcessingServiceCreateTaskAsyncResponses, AuthServiceChangePasswordData, AuthServiceChangePasswordResponses, AuthServiceCompleteOAuthData, AuthServiceCompleteOAuthResponses, AuthServiceGetMeData, AuthServiceGetMeResponses, AuthServiceLoginData, AuthServiceLoginResponses, AuthServiceLogoutData, AuthServiceLogoutResponses, AuthServiceRegisterData, AuthServiceRegisterResponses, AuthServiceResetPasswordData, AuthServiceResetPasswordResponses, AuthServiceSendVerificationCodeData, AuthServiceSendVerificationCodeResponses, AuthServiceStartOAuthData, AuthServiceStartOAuthResponses, AuthServiceUpdateProfileData, AuthServiceUpdateProfileResponses, AuthServiceVerifyVerificationCodeData, AuthServiceVerifyVerificationCodeResponses, AvatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallbackData, AvatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallbackResponses, AvatarServiceCancelPreprocessImageData, AvatarServiceCancelPreprocessImageResponses, AvatarServiceConfirmPreprocessImagePlanData, AvatarServiceConfirmPreprocessImagePlanResponses, AvatarServiceCopyAvatar2Data, AvatarServiceCopyAvatar2Responses, AvatarServiceCopyAvatarData, AvatarServiceCopyAvatarResponses, AvatarServiceCreateAvatar2Data, AvatarServiceCreateAvatar2Responses, AvatarServiceCreateAvatar3Data, AvatarServiceCreateAvatar3Responses, AvatarServiceCreateAvatarData, AvatarServiceCreateAvatarResponses, AvatarServiceCreateCustomAnimationData, AvatarServiceCreateCustomAnimationResponses, AvatarServiceCreatePreprocessImageData, AvatarServiceCreatePreprocessImageResponses, AvatarServiceDeleteAvatar2Data, AvatarServiceDeleteAvatar2Responses, AvatarServiceDeleteAvatarApplyData, AvatarServiceDeleteAvatarApplyResponses, AvatarServiceDeleteAvatarData, AvatarServiceDeleteAvatarResponses, AvatarServiceGenAnimationData, AvatarServiceGenAnimationResponses, AvatarServiceGenerateRawShapeDataData, AvatarServiceGenerateRawShapeDataResponses, AvatarServiceGenerateStyleDataData, AvatarServiceGenerateStyleDataResponses, AvatarServiceGetAvatar2Data, AvatarServiceGetAvatar2Responses, AvatarServiceGetAvatarApplyData, AvatarServiceGetAvatarApplyResponses, AvatarServiceGetAvatarData, AvatarServiceGetAvatarDetailData, AvatarServiceGetAvatarDetailResponses, AvatarServiceGetAvatarFilePresignedPutUrlData, AvatarServiceGetAvatarFilePresignedPutUrlResponses, AvatarServiceGetAvatarJobData, AvatarServiceGetAvatarJobResponses, AvatarServiceGetAvatarResponses, AvatarServiceGetAvatarsByIdsData, AvatarServiceGetAvatarsByIdsResponses, AvatarServiceGetPreprocessImageCandidateDownloadUrlData, AvatarServiceGetPreprocessImageCandidateDownloadUrlResponses, AvatarServiceGetPreprocessImageStatusData, AvatarServiceGetPreprocessImageStatusResponses, AvatarServiceListAvatarAppliesData, AvatarServiceListAvatarAppliesResponses, AvatarServiceListAvatarJobsData, AvatarServiceListAvatarJobsResponses, AvatarServiceListAvatars2Data, AvatarServiceListAvatars2Responses, AvatarServiceListAvatars3Data, AvatarServiceListAvatars3Responses, AvatarServiceListAvatarsData, AvatarServiceListAvatarsResponses, AvatarServiceListCustomAvatarsData, AvatarServiceListCustomAvatarsResponses, AvatarServiceListDrivenProvidersData, AvatarServiceListDrivenProvidersResponses, AvatarServiceListKlingMotionPresetsData, AvatarServiceListKlingMotionPresetsResponses, AvatarServicePreviewAnimationData, AvatarServicePreviewAnimationResponses, AvatarServiceRemoveCustomAnimationData, AvatarServiceRemoveCustomAnimationResponses, AvatarServiceRetryPreprocessImageSystemErrorData, AvatarServiceRetryPreprocessImageSystemErrorResponses, AvatarServiceSelectPreprocessImageCandidateData, AvatarServiceSelectPreprocessImageCandidateResponses, AvatarServiceUpdateAvatar2Data, AvatarServiceUpdateAvatar2Responses, AvatarServiceUpdateAvatarData, AvatarServiceUpdateAvatarResponses, AvatarServiceUpdateCustomAnimationData, AvatarServiceUpdateCustomAnimationResponses, AvatarUnitServiceGetAvatarUnitSummaryData, AvatarUnitServiceGetAvatarUnitSummaryResponses, AvatarUnitServiceListAvatarPipelinesData, AvatarUnitServiceListAvatarPipelinesResponses, AvatarUnitServiceListAvatarUnitPackagesData, AvatarUnitServiceListAvatarUnitPackagesResponses, AvatarUnitServiceListAvatarUnitTransactionsData, AvatarUnitServiceListAvatarUnitTransactionsResponses, AvatarUnitServicePurchaseAvatarUnitPackageData, AvatarUnitServicePurchaseAvatarUnitPackageResponses, BillingServiceCancelSubscriptionData, BillingServiceCancelSubscriptionResponses, BillingServiceCheckSessionPermissionData, BillingServiceCheckSessionPermissionResponses, BillingServiceCreateSubscriptionData, BillingServiceCreateSubscriptionResponses, BillingServiceDowngradeSubscriptionData, BillingServiceDowngradeSubscriptionResponses, BillingServiceGetAutoReloadConfigData, BillingServiceGetAutoReloadConfigResponses, BillingServiceGetCreditBalanceData, BillingServiceGetCreditBalanceResponses, BillingServiceGetCustomerPortalData, BillingServiceGetCustomerPortalResponses, BillingServiceGetSubscriptionData, BillingServiceGetSubscriptionResponses, BillingServiceGetUsageSummaryData, BillingServiceGetUsageSummaryResponses, BillingServiceListCreditPackagesData, BillingServiceListCreditPackagesResponses, BillingServiceListCreditTransactionsData, BillingServiceListCreditTransactionsResponses, BillingServiceListPlansData, BillingServiceListPlansResponses, BillingServicePurchaseCreditPackageData, BillingServicePurchaseCreditPackageResponses, BillingServiceResumeSubscriptionData, BillingServiceResumeSubscriptionResponses, BillingServiceSetupAutoReloadPaymentMethodData, BillingServiceSetupAutoReloadPaymentMethodResponses, BillingServiceUpdateAutoReloadConfigData, BillingServiceUpdateAutoReloadConfigResponses, BillingServiceUpgradeSubscriptionData, BillingServiceUpgradeSubscriptionResponses, ChatServiceCloseChatData, ChatServiceCloseChatResponses, ChatServiceCreateChatData, ChatServiceCreateChatResponses, ChatServiceGetChatData, ChatServiceGetChatResponses, ChatServiceListChatsData, ChatServiceListChatsResponses, ChatServiceSendChatMessageData, ChatServiceSendChatMessageResponses, ChatServiceSetChatReadData, ChatServiceSetChatReadResponses, CliAuthServiceApproveCliAuthSessionData, CliAuthServiceApproveCliAuthSessionResponses, CliAuthServiceCreateCliAuthSessionData, CliAuthServiceCreateCliAuthSessionResponses, CliAuthServiceExchangeCliAuthTokenData, CliAuthServiceExchangeCliAuthTokenResponses, CliAuthServiceGetCliAuthSessionData, CliAuthServiceGetCliAuthSessionResponses, CliAuthServiceRefreshCliAuthTokenData, CliAuthServiceRefreshCliAuthTokenResponses, CliAuthServiceRevokeCliAuthTokenData, CliAuthServiceRevokeCliAuthTokenResponses, CollectionTaskServiceCreateCollectionTaskData, CollectionTaskServiceCreateCollectionTaskResponses, CollectionTaskServiceDeleteCollectionTaskData, CollectionTaskServiceDeleteCollectionTaskResponses, CollectionTaskServiceGetCollectionTaskByTokenData, CollectionTaskServiceGetCollectionTaskByTokenResponses, CollectionTaskServiceGetCollectionTaskData, CollectionTaskServiceGetCollectionTaskOssCredentialsData, CollectionTaskServiceGetCollectionTaskOssCredentialsResponses, CollectionTaskServiceGetCollectionTaskResponses, CollectionTaskServiceListCollectionTasksData, CollectionTaskServiceListCollectionTasksResponses, CollectionTaskServiceSubmitCollectionFileData, CollectionTaskServiceSubmitCollectionFileResponses, CollectionTaskServiceUpdateCollectionTaskData, CollectionTaskServiceUpdateCollectionTaskResponses, CommonServiceGetR2PresignedPutUrlData, CommonServiceGetR2PresignedPutUrlResponses, ConsoleServiceCreateSessionTokenData, ConsoleServiceCreateSessionTokenResponses, ConsoleServiceGetOssCredentialsData, ConsoleServiceGetOssCredentialsResponses, DrivenIngressServiceGetAvatarInfoData, DrivenIngressServiceGetAvatarInfoResponses, DrivenIngressServiceGetCharacterInfoData, DrivenIngressServiceGetCharacterInfoResponses, DrivenIngressServiceV3GetAvatarInfoData, DrivenIngressServiceV3GetAvatarInfoResponses, DrivenStatsServiceGetAllRegionsStatsData, DrivenStatsServiceGetAllRegionsStatsResponses, DrivenStatsServiceGetRegionStatsData, DrivenStatsServiceGetRegionStatsResponses, DrivenStatsServiceSyncDrivenStatsData, DrivenStatsServiceSyncDrivenStatsResponses, DrivingModelServiceCreateDrivingModelData, DrivingModelServiceCreateDrivingModelResponses, DrivingModelServiceDeleteDrivingModelData, DrivingModelServiceDeleteDrivingModelResponses, DrivingModelServiceGetDrivingModelData, DrivingModelServiceGetDrivingModelResponses, DrivingModelServiceListDrivingModelsData, DrivingModelServiceListDrivingModelsResponses, DrivingModelServiceUpdateDrivingModelData, DrivingModelServiceUpdateDrivingModelResponses, FeedbackTicketServiceAdminCreateFeedbackReplyData, FeedbackTicketServiceAdminCreateFeedbackReplyResponses, FeedbackTicketServiceAdminCreateFeedbackTicketData, FeedbackTicketServiceAdminCreateFeedbackTicketResponses, FeedbackTicketServiceAdminGetFeedbackTicketData, FeedbackTicketServiceAdminGetFeedbackTicketResponses, FeedbackTicketServiceAdminListFeedbackTicketsData, FeedbackTicketServiceAdminListFeedbackTicketsResponses, FeedbackTicketServiceAdminUpdateTicketStatusData, FeedbackTicketServiceAdminUpdateTicketStatusResponses, FeedbackTicketServiceCloseFeedbackTicketData, FeedbackTicketServiceCloseFeedbackTicketResponses, FeedbackTicketServiceCreateFeedbackReplyData, FeedbackTicketServiceCreateFeedbackReplyResponses, FeedbackTicketServiceCreateFeedbackTicketData, FeedbackTicketServiceCreateFeedbackTicketResponses, FeedbackTicketServiceGetFeedbackTicketData, FeedbackTicketServiceGetFeedbackTicketResponses, FeedbackTicketServiceListMyFeedbackTicketsData, FeedbackTicketServiceListMyFeedbackTicketsResponses, FeedbackTicketServiceUpdateFeedbackTicketData, FeedbackTicketServiceUpdateFeedbackTicketResponses, IframeVersionServiceListIframeVersionsData, IframeVersionServiceListIframeVersionsResponses, InboxServiceDeleteNotificationData, InboxServiceDeleteNotificationResponses, InboxServiceGetSummaryData, InboxServiceGetSummaryResponses, InboxServiceListNotificationsData, InboxServiceListNotificationsResponses, InboxServiceMarkAllReadData, InboxServiceMarkAllReadResponses, InboxServiceSetNotificationReadData, InboxServiceSetNotificationReadResponses, InstanceManagementServiceListContainerImagesData, InstanceManagementServiceListContainerImagesResponses, InstanceManagementServiceListContainerImageTagsData, InstanceManagementServiceListContainerImageTagsResponses, InstanceManagementServiceListInstancesData, InstanceManagementServiceListInstancesResponses, InstanceManagementServiceListLaunchTemplatesData, InstanceManagementServiceListLaunchTemplatesResponses, MaterialServiceAdjustMaterialData, MaterialServiceAdjustMaterialResponses, MaterialServiceCreateMaterialData, MaterialServiceCreateMaterialResponses, MaterialServiceDeleteMaterialData, MaterialServiceDeleteMaterialResponses, MaterialServiceGetMaterialData, MaterialServiceGetMaterialResponses, MaterialServiceListMaterialsData, MaterialServiceListMaterialsResponses, MaterialServiceUpdateMaterialData, MaterialServiceUpdateMaterialResponses, NotificationServiceGetUnreadNotificationCountData, NotificationServiceGetUnreadNotificationCountResponses, NotificationServiceListNotificationsData, NotificationServiceListNotificationsResponses, NotificationServiceMarkAllNotificationsReadData, NotificationServiceMarkAllNotificationsReadResponses, NotificationServiceMarkNotificationReadData, NotificationServiceMarkNotificationReadResponses, PipeTemplateServiceCreatePipeTemplateData, PipeTemplateServiceCreatePipeTemplateResponses, PipeTemplateServiceDeletePipeTemplateData, PipeTemplateServiceDeletePipeTemplateResponses, PipeTemplateServiceGetPipeTemplateData, PipeTemplateServiceGetPipeTemplateResponses, PipeTemplateServiceListPipeTemplatesData, PipeTemplateServiceListPipeTemplatesResponses, PipeTemplateServiceListTrackerVersionsData, PipeTemplateServiceListTrackerVersionsResponses, PipeTemplateServiceUpdatePipeTemplateData, PipeTemplateServiceUpdatePipeTemplateResponses, PublicAvatarServiceListPublicAvatarsData, PublicAvatarServiceListPublicAvatarsResponses, StudioVoiceAgentServiceCreateStudioConversationSessionData, StudioVoiceAgentServiceCreateStudioConversationSessionResponses, StudioVoiceAgentServiceListStudioVoicesData, StudioVoiceAgentServiceListStudioVoicesResponses, TaskHeartbeatServiceHeartbeatData, TaskHeartbeatServiceHeartbeatResponses, TaskServiceCreateStatusData, TaskServiceCreateStatusResponses, TaskServiceCreateTaskData, TaskServiceCreateTaskResponses, TaskServiceDeleteStatusData, TaskServiceDeleteStatusResponses, TaskServiceDeleteTaskData, TaskServiceDeleteTaskResponses, TaskServiceGetStatusData, TaskServiceGetStatusResponses, TaskServiceGetTaskData, TaskServiceGetTaskResponses, TaskServiceGetTaskStatsData, TaskServiceGetTaskStatsResponses, TaskServiceListStatusesData, TaskServiceListStatusesResponses, TaskServiceListTasksData, TaskServiceListTasksResponses, TaskServiceTerminateTaskInstancesData, TaskServiceTerminateTaskInstancesResponses, TaskServiceUpdateStatusData, TaskServiceUpdateStatusResponses, TaskServiceUpdateTaskData, TaskServiceUpdateTaskResponses, UserDrivenStatsServiceGetRealtimeConcurrentConnectionsData, UserDrivenStatsServiceGetRealtimeConcurrentConnectionsResponses, UserDrivenStatsServiceGetSessionCountData, UserDrivenStatsServiceGetSessionCountResponses, UserDrivenStatsServiceGetUsageData, UserDrivenStatsServiceGetUsageResponses, UserDrivenStatsServiceListConnectionLogsData, UserDrivenStatsServiceListConnectionLogsResponses, VendorAuthServiceCompleteLoginData, VendorAuthServiceCompleteLoginResponses, VendorAuthServiceGetMeData, VendorAuthServiceGetMeResponses, VendorAuthServiceLogoutData, VendorAuthServiceLogoutResponses, VendorAuthServiceStartLoginData, VendorAuthServiceStartLoginResponses, VendorInvitationServiceGetMyVendorData, VendorInvitationServiceGetMyVendorResponses, VendorInvitationServiceResolveInvitationData, VendorInvitationServiceResolveInvitationResponses, VendorServiceCreateInvitationData, VendorServiceCreateInvitationResponses, VendorServiceGetCustomerData, VendorServiceGetCustomerResponses, VendorServiceGetInvitationLinkData, VendorServiceGetInvitationLinkResponses, VendorServiceListCustomerAvatarsData, VendorServiceListCustomerAvatarsResponses, VendorServiceListCustomersData, VendorServiceListCustomersResponses, VendorServiceListInvitationsData, VendorServiceListInvitationsResponses, VendorServiceRevokeInvitationData, VendorServiceRevokeInvitationResponses, VideoServiceCreateVideoData, VideoServiceCreateVideoResponses, VideoServiceGetVideoJobData, VideoServiceGetVideoJobResponses, VideoServiceListVideoJobsData, VideoServiceListVideoJobsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List connection logs for the authenticated user
 */
export const userDrivenStatsServiceListConnectionLogs = <ThrowOnError extends boolean = false>(options?: Options<UserDrivenStatsServiceListConnectionLogsData, ThrowOnError>) => {
    return (options?.client ?? client).get<UserDrivenStatsServiceListConnectionLogsResponses, unknown, ThrowOnError>({
        url: '/api/console/v2/stats/connection-logs',
        ...options
    });
};

/**
 * Get realtime concurrent connections for the authenticated user
 */
export const userDrivenStatsServiceGetRealtimeConcurrentConnections = <ThrowOnError extends boolean = false>(options?: Options<UserDrivenStatsServiceGetRealtimeConcurrentConnectionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<UserDrivenStatsServiceGetRealtimeConcurrentConnectionsResponses, unknown, ThrowOnError>({
        url: '/api/console/v2/stats/realtime-connections',
        ...options
    });
};

/**
 * Get session count time series for the authenticated user
 */
export const userDrivenStatsServiceGetSessionCount = <ThrowOnError extends boolean = false>(options?: Options<UserDrivenStatsServiceGetSessionCountData, ThrowOnError>) => {
    return (options?.client ?? client).get<UserDrivenStatsServiceGetSessionCountResponses, unknown, ThrowOnError>({
        url: '/api/console/v2/stats/session-count',
        ...options
    });
};

/**
 * Get audio usage time series for the authenticated user
 */
export const userDrivenStatsServiceGetUsage = <ThrowOnError extends boolean = false>(options?: Options<UserDrivenStatsServiceGetUsageData, ThrowOnError>) => {
    return (options?.client ?? client).get<UserDrivenStatsServiceGetUsageResponses, unknown, ThrowOnError>({
        url: '/api/console/v2/stats/usage',
        ...options
    });
};

/**
 * Admin-facing
 */
export const feedbackTicketServiceAdminListFeedbackTickets = <ThrowOnError extends boolean = false>(options?: Options<FeedbackTicketServiceAdminListFeedbackTicketsData, ThrowOnError>) => {
    return (options?.client ?? client).get<FeedbackTicketServiceAdminListFeedbackTicketsResponses, unknown, ThrowOnError>({
        url: '/api/v1/admin/feedback/tickets',
        ...options
    });
};

export const feedbackTicketServiceAdminCreateFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceAdminCreateFeedbackTicketData, ThrowOnError>) => {
    return (options.client ?? client).post<FeedbackTicketServiceAdminCreateFeedbackTicketResponses, unknown, ThrowOnError>({
        url: '/api/v1/admin/feedback/tickets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feedbackTicketServiceAdminGetFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceAdminGetFeedbackTicketData, ThrowOnError>) => {
    return (options.client ?? client).get<FeedbackTicketServiceAdminGetFeedbackTicketResponses, unknown, ThrowOnError>({
        url: '/api/v1/admin/feedback/tickets/{id}',
        ...options
    });
};

export const feedbackTicketServiceAdminUpdateTicketStatus = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceAdminUpdateTicketStatusData, ThrowOnError>) => {
    return (options.client ?? client).patch<FeedbackTicketServiceAdminUpdateTicketStatusResponses, unknown, ThrowOnError>({
        url: '/api/v1/admin/feedback/tickets/{id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feedbackTicketServiceAdminCreateFeedbackReply = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceAdminCreateFeedbackReplyData, ThrowOnError>) => {
    return (options.client ?? client).post<FeedbackTicketServiceAdminCreateFeedbackReplyResponses, unknown, ThrowOnError>({
        url: '/api/v1/admin/feedback/tickets/{ticketId}/replies',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feedbackTicketServiceListMyFeedbackTickets = <ThrowOnError extends boolean = false>(options?: Options<FeedbackTicketServiceListMyFeedbackTicketsData, ThrowOnError>) => {
    return (options?.client ?? client).get<FeedbackTicketServiceListMyFeedbackTicketsResponses, unknown, ThrowOnError>({
        url: '/api/v1/feedback/tickets',
        ...options
    });
};

/**
 * User-facing
 */
export const feedbackTicketServiceCreateFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceCreateFeedbackTicketData, ThrowOnError>) => {
    return (options.client ?? client).post<FeedbackTicketServiceCreateFeedbackTicketResponses, unknown, ThrowOnError>({
        url: '/api/v1/feedback/tickets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feedbackTicketServiceGetFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceGetFeedbackTicketData, ThrowOnError>) => {
    return (options.client ?? client).get<FeedbackTicketServiceGetFeedbackTicketResponses, unknown, ThrowOnError>({
        url: '/api/v1/feedback/tickets/{id}',
        ...options
    });
};

export const feedbackTicketServiceUpdateFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceUpdateFeedbackTicketData, ThrowOnError>) => {
    return (options.client ?? client).patch<FeedbackTicketServiceUpdateFeedbackTicketResponses, unknown, ThrowOnError>({
        url: '/api/v1/feedback/tickets/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feedbackTicketServiceCloseFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceCloseFeedbackTicketData, ThrowOnError>) => {
    return (options.client ?? client).post<FeedbackTicketServiceCloseFeedbackTicketResponses, unknown, ThrowOnError>({
        url: '/api/v1/feedback/tickets/{id}/close',
        ...options
    });
};

export const feedbackTicketServiceCreateFeedbackReply = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceCreateFeedbackReplyData, ThrowOnError>) => {
    return (options.client ?? client).post<FeedbackTicketServiceCreateFeedbackReplyResponses, unknown, ThrowOnError>({
        url: '/api/v1/feedback/tickets/{ticketId}/replies',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all admin users
 */
export const adminUserServiceListAdminUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminUserServiceListAdminUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminUserServiceListAdminUsersResponses, unknown, ThrowOnError>({
        url: '/v1/admin/admin-users',
        ...options
    });
};

/**
 * Create a new admin user
 */
export const adminUserServiceCreateAdminUser = <ThrowOnError extends boolean = false>(options: Options<AdminUserServiceCreateAdminUserData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminUserServiceCreateAdminUserResponses, unknown, ThrowOnError>({
        url: '/v1/admin/admin-users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete an admin user
 */
export const adminUserServiceDeleteAdminUser = <ThrowOnError extends boolean = false>(options: Options<AdminUserServiceDeleteAdminUserData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminUserServiceDeleteAdminUserResponses, unknown, ThrowOnError>({
        url: '/v1/admin/admin-users/{adminUserId}',
        ...options
    });
};

/**
 * List all API keys with optional app_id and user_id filters
 */
export const adminAppServiceListApiKeys = <ThrowOnError extends boolean = false>(options?: Options<AdminAppServiceListApiKeysData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAppServiceListApiKeysResponses, unknown, ThrowOnError>({
        url: '/v1/admin/api-keys',
        ...options
    });
};

/**
 * List all applications with optional user ID filter
 */
export const adminAppServiceListApps = <ThrowOnError extends boolean = false>(options?: Options<AdminAppServiceListAppsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAppServiceListAppsResponses, unknown, ThrowOnError>({
        url: '/v1/admin/apps',
        ...options
    });
};

/**
 * Get application detail by app_id
 */
export const adminAppServiceGetApp = <ThrowOnError extends boolean = false>(options: Options<AdminAppServiceGetAppData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminAppServiceGetAppResponses, unknown, ThrowOnError>({
        url: '/v1/admin/apps/{appId}',
        ...options
    });
};

/**
 * Change password
 */
export const adminAuthServiceChangePassword = <ThrowOnError extends boolean = false>(options: Options<AdminAuthServiceChangePasswordData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAuthServiceChangePasswordResponses, unknown, ThrowOnError>({
        url: '/v1/admin/auth/change-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Login with email and password
 */
export const adminAuthServiceLogin = <ThrowOnError extends boolean = false>(options: Options<AdminAuthServiceLoginData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAuthServiceLoginResponses, unknown, ThrowOnError>({
        url: '/v1/admin/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminAuthenticationServiceGetStatus = <ThrowOnError extends boolean = false>(options?: Options<AdminAuthenticationServiceGetStatusData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAuthenticationServiceGetStatusResponses, unknown, ThrowOnError>({
        url: '/v1/admin/authentication',
        ...options
    });
};

export const adminAuthenticationServiceListAudit = <ThrowOnError extends boolean = false>(options?: Options<AdminAuthenticationServiceListAuditData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAuthenticationServiceListAuditResponses, unknown, ThrowOnError>({
        url: '/v1/admin/authentication/audit',
        ...options
    });
};

export const adminAuthenticationServiceListOperations = <ThrowOnError extends boolean = false>(options?: Options<AdminAuthenticationServiceListOperationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAuthenticationServiceListOperationsResponses, unknown, ThrowOnError>({
        url: '/v1/admin/authentication/operations',
        ...options
    });
};

/**
 * Credential operations reconcile known results only; they never replay a
 * password write or restore a previous password.
 */
export const adminAuthenticationServiceRetryOperation = <ThrowOnError extends boolean = false>(options: Options<AdminAuthenticationServiceRetryOperationData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAuthenticationServiceRetryOperationResponses, unknown, ThrowOnError>({
        url: '/v1/admin/authentication/operations/{operationId}/retry',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminAuthenticationServiceGetUserState = <ThrowOnError extends boolean = false>(options: Options<AdminAuthenticationServiceGetUserStateData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminAuthenticationServiceGetUserStateResponses, unknown, ThrowOnError>({
        url: '/v1/admin/authentication/users/{userId}',
        ...options
    });
};

/**
 * Reconcile only an established WorkOS mapping or a persisted signup operation.
 * Email matching and arbitrary identity overrides are not supported.
 */
export const adminAuthenticationServiceReconcileUser = <ThrowOnError extends boolean = false>(options: Options<AdminAuthenticationServiceReconcileUserData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAuthenticationServiceReconcileUserResponses, unknown, ThrowOnError>({
        url: '/v1/admin/authentication/users/{userId}/reconcile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all console configs
 */
export const adminConfigServiceAdminListConfigs = <ThrowOnError extends boolean = false>(options?: Options<AdminConfigServiceAdminListConfigsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminConfigServiceAdminListConfigsResponses, unknown, ThrowOnError>({
        url: '/v1/admin/configs',
        ...options
    });
};

/**
 * Create a new console config
 */
export const adminConfigServiceAdminCreateConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminCreateConfigData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminConfigServiceAdminCreateConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/configs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a console config
 */
export const adminConfigServiceAdminDeleteConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminDeleteConfigData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminConfigServiceAdminDeleteConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/configs/{key}',
        ...options
    });
};

/**
 * Get console config by key
 */
export const adminConfigServiceAdminGetConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminGetConfigData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminConfigServiceAdminGetConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/configs/{key}',
        ...options
    });
};

/**
 * Update an existing console config
 */
export const adminConfigServiceAdminUpdateConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminUpdateConfigData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminConfigServiceAdminUpdateConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/configs/{key}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminDrivenIngressAvatarAccessServiceListUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenIngressAvatarAccessServiceListUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenIngressAvatarAccessServiceListUsersResponses, unknown, ThrowOnError>({
        url: '/v1/admin/driven-ingress-avatar-access-users',
        ...options
    });
};

export const adminDrivenIngressAvatarAccessServiceCreateUser = <ThrowOnError extends boolean = false>(options: Options<AdminDrivenIngressAvatarAccessServiceCreateUserData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminDrivenIngressAvatarAccessServiceCreateUserResponses, unknown, ThrowOnError>({
        url: '/v1/admin/driven-ingress-avatar-access-users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminDrivenIngressAvatarAccessServiceDeleteUser = <ThrowOnError extends boolean = false>(options: Options<AdminDrivenIngressAvatarAccessServiceDeleteUserData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminDrivenIngressAvatarAccessServiceDeleteUserResponses, unknown, ThrowOnError>({
        url: '/v1/admin/driven-ingress-avatar-access-users/{id}',
        ...options
    });
};

export const adminDrivenIngressAvatarAccessServiceUpdateUser = <ThrowOnError extends boolean = false>(options: Options<AdminDrivenIngressAvatarAccessServiceUpdateUserData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminDrivenIngressAvatarAccessServiceUpdateUserResponses, unknown, ThrowOnError>({
        url: '/v1/admin/driven-ingress-avatar-access-users/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * GetAllRegionsStats returns aggregated real-time stats from all regions
 * Only available on the primary Console (SV), aggregates data from BJ, TYO, SV
 */
export const drivenStatsServiceGetAllRegionsStats = <ThrowOnError extends boolean = false>(options?: Options<DrivenStatsServiceGetAllRegionsStatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<DrivenStatsServiceGetAllRegionsStatsResponses, unknown, ThrowOnError>({
        url: '/v1/admin/driven-stats/all-regions',
        ...options
    });
};

/**
 * List iframe version configurations.
 */
export const adminIframeVersionServiceAdminListIframeVersions = <ThrowOnError extends boolean = false>(options?: Options<AdminIframeVersionServiceAdminListIframeVersionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminIframeVersionServiceAdminListIframeVersionsResponses, unknown, ThrowOnError>({
        url: '/v1/admin/iframe-versions',
        ...options
    });
};

/**
 * Create one iframe version configuration.
 */
export const adminIframeVersionServiceAdminCreateIframeVersion = <ThrowOnError extends boolean = false>(options: Options<AdminIframeVersionServiceAdminCreateIframeVersionData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminIframeVersionServiceAdminCreateIframeVersionResponses, unknown, ThrowOnError>({
        url: '/v1/admin/iframe-versions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete one iframe version configuration.
 */
export const adminIframeVersionServiceAdminDeleteIframeVersion = <ThrowOnError extends boolean = false>(options: Options<AdminIframeVersionServiceAdminDeleteIframeVersionData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminIframeVersionServiceAdminDeleteIframeVersionResponses, unknown, ThrowOnError>({
        url: '/v1/admin/iframe-versions/{version}',
        ...options
    });
};

/**
 * Get one iframe version configuration.
 */
export const adminIframeVersionServiceAdminGetIframeVersion = <ThrowOnError extends boolean = false>(options: Options<AdminIframeVersionServiceAdminGetIframeVersionData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminIframeVersionServiceAdminGetIframeVersionResponses, unknown, ThrowOnError>({
        url: '/v1/admin/iframe-versions/{version}',
        ...options
    });
};

/**
 * Update one iframe version configuration. This replaces all editable fields for the version.
 */
export const adminIframeVersionServiceAdminUpdateIframeVersion = <ThrowOnError extends boolean = false>(options: Options<AdminIframeVersionServiceAdminUpdateIframeVersionData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminIframeVersionServiceAdminUpdateIframeVersionResponses, unknown, ThrowOnError>({
        url: '/v1/admin/iframe-versions/{version}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminStudioVoiceAgentProviderServiceAdminListStudioVoiceAgentProviders = <ThrowOnError extends boolean = false>(options?: Options<AdminStudioVoiceAgentProviderServiceAdminListStudioVoiceAgentProvidersData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminStudioVoiceAgentProviderServiceAdminListStudioVoiceAgentProvidersResponses, unknown, ThrowOnError>({
        url: '/v1/admin/studio-voice-agent-providers',
        ...options
    });
};

export const adminStudioVoiceAgentProviderServiceAdminCreateStudioVoiceAgentProvider = <ThrowOnError extends boolean = false>(options: Options<AdminStudioVoiceAgentProviderServiceAdminCreateStudioVoiceAgentProviderData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminStudioVoiceAgentProviderServiceAdminCreateStudioVoiceAgentProviderResponses, unknown, ThrowOnError>({
        url: '/v1/admin/studio-voice-agent-providers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminStudioVoiceAgentProviderServiceAdminDeleteStudioVoiceAgentProvider = <ThrowOnError extends boolean = false>(options: Options<AdminStudioVoiceAgentProviderServiceAdminDeleteStudioVoiceAgentProviderData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminStudioVoiceAgentProviderServiceAdminDeleteStudioVoiceAgentProviderResponses, unknown, ThrowOnError>({
        url: '/v1/admin/studio-voice-agent-providers/{id}',
        ...options
    });
};

export const adminStudioVoiceAgentProviderServiceAdminGetStudioVoiceAgentProvider = <ThrowOnError extends boolean = false>(options: Options<AdminStudioVoiceAgentProviderServiceAdminGetStudioVoiceAgentProviderData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminStudioVoiceAgentProviderServiceAdminGetStudioVoiceAgentProviderResponses, unknown, ThrowOnError>({
        url: '/v1/admin/studio-voice-agent-providers/{id}',
        ...options
    });
};

export const adminStudioVoiceAgentProviderServiceAdminUpdateStudioVoiceAgentProvider = <ThrowOnError extends boolean = false>(options: Options<AdminStudioVoiceAgentProviderServiceAdminUpdateStudioVoiceAgentProviderData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminStudioVoiceAgentProviderServiceAdminUpdateStudioVoiceAgentProviderResponses, unknown, ThrowOnError>({
        url: '/v1/admin/studio-voice-agent-providers/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminStudioVoiceAgentProviderServiceAdminGetStudioVoiceAgentConfig = <ThrowOnError extends boolean = false>(options?: Options<AdminStudioVoiceAgentProviderServiceAdminGetStudioVoiceAgentConfigData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminStudioVoiceAgentProviderServiceAdminGetStudioVoiceAgentConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/studio-voice-agent/config',
        ...options
    });
};

export const adminStudioVoiceAgentProviderServiceAdminUpdateStudioVoiceAgentConfig = <ThrowOnError extends boolean = false>(options: Options<AdminStudioVoiceAgentProviderServiceAdminUpdateStudioVoiceAgentConfigData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminStudioVoiceAgentProviderServiceAdminUpdateStudioVoiceAgentConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/studio-voice-agent/config',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all console user characters with optional filters
 */
export const adminUserCharacterServiceAdminListUserCharacters = <ThrowOnError extends boolean = false>(options?: Options<AdminUserCharacterServiceAdminListUserCharactersData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminUserCharacterServiceAdminListUserCharactersResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-characters',
        ...options
    });
};

/**
 * Create a new console user character
 */
export const adminUserCharacterServiceAdminCreateUserCharacter = <ThrowOnError extends boolean = false>(options: Options<AdminUserCharacterServiceAdminCreateUserCharacterData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminUserCharacterServiceAdminCreateUserCharacterResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-characters',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a console user character
 */
export const adminUserCharacterServiceAdminDeleteUserCharacter = <ThrowOnError extends boolean = false>(options: Options<AdminUserCharacterServiceAdminDeleteUserCharacterData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminUserCharacterServiceAdminDeleteUserCharacterResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-characters/{id}',
        ...options
    });
};

/**
 * Get console user character by ID
 */
export const adminUserCharacterServiceAdminGetUserCharacter = <ThrowOnError extends boolean = false>(options: Options<AdminUserCharacterServiceAdminGetUserCharacterData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminUserCharacterServiceAdminGetUserCharacterResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-characters/{id}',
        ...options
    });
};

/**
 * Update an existing console user character
 */
export const adminUserCharacterServiceAdminUpdateUserCharacter = <ThrowOnError extends boolean = false>(options: Options<AdminUserCharacterServiceAdminUpdateUserCharacterData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUserCharacterServiceAdminUpdateUserCharacterResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-characters/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all console user configs with optional user_id filter
 */
export const adminConfigServiceAdminListUserConfigs = <ThrowOnError extends boolean = false>(options?: Options<AdminConfigServiceAdminListUserConfigsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminConfigServiceAdminListUserConfigsResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-configs',
        ...options
    });
};

/**
 * Create a new console user config
 */
export const adminConfigServiceAdminCreateUserConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminCreateUserConfigData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminConfigServiceAdminCreateUserConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-configs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get console user config by user_id
 */
export const adminConfigServiceAdminGetUserConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminGetUserConfigData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminConfigServiceAdminGetUserConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-configs/{userId}',
        ...options
    });
};

/**
 * Update console user config
 */
export const adminConfigServiceAdminUpdateUserConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminUpdateUserConfigData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminConfigServiceAdminUpdateUserConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-configs/{userId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add avatar generation quota to a user
 */
export const adminConfigServiceAdminAddAvatarQuota = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminAddAvatarQuotaData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminConfigServiceAdminAddAvatarQuotaResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-configs/{userId}/add-quota',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all console users
 */
export const adminUserServiceListUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminUserServiceListUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminUserServiceListUsersResponses, unknown, ThrowOnError>({
        url: '/v1/admin/users',
        ...options
    });
};

/**
 * Update remark for a console user
 */
export const adminUserServiceUpdateUserRemark = <ThrowOnError extends boolean = false>(options: Options<AdminUserServiceUpdateUserRemarkData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUserServiceUpdateUserRemarkResponses, unknown, ThrowOnError>({
        url: '/v1/admin/users/{userId}/remark',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminVendorServiceListVendors = <ThrowOnError extends boolean = false>(options?: Options<AdminVendorServiceListVendorsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminVendorServiceListVendorsResponses, unknown, ThrowOnError>({
        url: '/v1/admin/vendors',
        ...options
    });
};

export const adminVendorServiceCreateVendor = <ThrowOnError extends boolean = false>(options: Options<AdminVendorServiceCreateVendorData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminVendorServiceCreateVendorResponses, unknown, ThrowOnError>({
        url: '/v1/admin/vendors',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminVendorServiceUpdateVendor = <ThrowOnError extends boolean = false>(options: Options<AdminVendorServiceUpdateVendorData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminVendorServiceUpdateVendorResponses, unknown, ThrowOnError>({
        url: '/v1/admin/vendors/{vendorId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminVendorServiceListAdministrators = <ThrowOnError extends boolean = false>(options: Options<AdminVendorServiceListAdministratorsData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminVendorServiceListAdministratorsResponses, unknown, ThrowOnError>({
        url: '/v1/admin/vendors/{vendorId}/administrators',
        ...options
    });
};

export const adminVendorServiceProvisionAdministrator = <ThrowOnError extends boolean = false>(options: Options<AdminVendorServiceProvisionAdministratorData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminVendorServiceProvisionAdministratorResponses, unknown, ThrowOnError>({
        url: '/v1/admin/vendors/{vendorId}/administrators',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminVendorServiceRevokeAdministrator = <ThrowOnError extends boolean = false>(options: Options<AdminVendorServiceRevokeAdministratorData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminVendorServiceRevokeAdministratorResponses, unknown, ThrowOnError>({
        url: '/v1/admin/vendors/{vendorId}/administrators/{membershipId}/revoke',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminVendorServiceListCustomers = <ThrowOnError extends boolean = false>(options: Options<AdminVendorServiceListCustomersData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminVendorServiceListCustomersResponses, unknown, ThrowOnError>({
        url: '/v1/admin/vendors/{vendorId}/customers',
        ...options
    });
};

export const adminVendorServiceAttachCustomer = <ThrowOnError extends boolean = false>(options: Options<AdminVendorServiceAttachCustomerData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminVendorServiceAttachCustomerResponses, unknown, ThrowOnError>({
        url: '/v1/admin/vendors/{vendorId}/customers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminVendorServiceUnlinkCustomer = <ThrowOnError extends boolean = false>(options: Options<AdminVendorServiceUnlinkCustomerData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminVendorServiceUnlinkCustomerResponses, unknown, ThrowOnError>({
        url: '/v1/admin/vendors/{vendorId}/customers/{assignmentId}/unlink',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminVendorServiceListInvitations = <ThrowOnError extends boolean = false>(options: Options<AdminVendorServiceListInvitationsData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminVendorServiceListInvitationsResponses, unknown, ThrowOnError>({
        url: '/v1/admin/vendors/{vendorId}/invitations',
        ...options
    });
};

/**
 * List all applications with pagination
 */
export const appServiceListApps = <ThrowOnError extends boolean = false>(options?: Options<AppServiceListAppsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AppServiceListAppsResponses, unknown, ThrowOnError>({
        url: '/v1/apps',
        ...options
    });
};

/**
 * Create a new application
 */
export const appServiceCreateApp = <ThrowOnError extends boolean = false>(options: Options<AppServiceCreateAppData, ThrowOnError>) => {
    return (options.client ?? client).post<AppServiceCreateAppResponses, unknown, ThrowOnError>({
        url: '/v1/apps',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete an application and all its associated API keys
 */
export const appServiceDeleteApp = <ThrowOnError extends boolean = false>(options: Options<AppServiceDeleteAppData, ThrowOnError>) => {
    return (options.client ?? client).delete<AppServiceDeleteAppResponses, unknown, ThrowOnError>({
        url: '/v1/apps/{appId}',
        ...options
    });
};

/**
 * Get a specific application by ID
 */
export const appServiceGetApp = <ThrowOnError extends boolean = false>(options: Options<AppServiceGetAppData, ThrowOnError>) => {
    return (options.client ?? client).get<AppServiceGetAppResponses, unknown, ThrowOnError>({
        url: '/v1/apps/{appId}',
        ...options
    });
};

/**
 * List all API keys for an application
 */
export const appServiceListApiKeys = <ThrowOnError extends boolean = false>(options: Options<AppServiceListApiKeysData, ThrowOnError>) => {
    return (options.client ?? client).get<AppServiceListApiKeysResponses, unknown, ThrowOnError>({
        url: '/v1/apps/{appId}/api-keys',
        ...options
    });
};

/**
 * Create a new API key for an application
 */
export const appServiceCreateApiKey = <ThrowOnError extends boolean = false>(options: Options<AppServiceCreateApiKeyData, ThrowOnError>) => {
    return (options.client ?? client).post<AppServiceCreateApiKeyResponses, unknown, ThrowOnError>({
        url: '/v1/apps/{appId}/api-keys',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a specific API key
 */
export const appServiceDeleteApiKey = <ThrowOnError extends boolean = false>(options: Options<AppServiceDeleteApiKeyData, ThrowOnError>) => {
    return (options.client ?? client).delete<AppServiceDeleteApiKeyResponses, unknown, ThrowOnError>({
        url: '/v1/apps/{appId}/api-keys/{apiKey}',
        ...options
    });
};

export const assetGroupServiceListAssetGroups = <ThrowOnError extends boolean = false>(options?: Options<AssetGroupServiceListAssetGroupsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AssetGroupServiceListAssetGroupsResponses, unknown, ThrowOnError>({
        url: '/v1/asset-groups',
        ...options
    });
};

export const assetGroupServiceCreateAssetGroup = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceCreateAssetGroupData, ThrowOnError>) => {
    return (options.client ?? client).post<AssetGroupServiceCreateAssetGroupResponses, unknown, ThrowOnError>({
        url: '/v1/asset-groups',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const assetGroupServiceDeleteAssetGroup = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceDeleteAssetGroupData, ThrowOnError>) => {
    return (options.client ?? client).delete<AssetGroupServiceDeleteAssetGroupResponses, unknown, ThrowOnError>({
        url: '/v1/asset-groups/{id}',
        ...options
    });
};

export const assetGroupServiceGetAssetGroup = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceGetAssetGroupData, ThrowOnError>) => {
    return (options.client ?? client).get<AssetGroupServiceGetAssetGroupResponses, unknown, ThrowOnError>({
        url: '/v1/asset-groups/{id}',
        ...options
    });
};

export const assetGroupServiceUpdateAssetGroup = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceUpdateAssetGroupData, ThrowOnError>) => {
    return (options.client ?? client).patch<AssetGroupServiceUpdateAssetGroupResponses, unknown, ThrowOnError>({
        url: '/v1/asset-groups/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const assetGroupServiceReplaceAssetGroupAsset = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceReplaceAssetGroupAssetData, ThrowOnError>) => {
    return (options.client ?? client).post<AssetGroupServiceReplaceAssetGroupAssetResponses, unknown, ThrowOnError>({
        url: '/v1/asset-groups/{id}:replaceAsset',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const assetGroupServiceGetAssetGroupsByIds = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceGetAssetGroupsByIdsData, ThrowOnError>) => {
    return (options.client ?? client).post<AssetGroupServiceGetAssetGroupsByIdsResponses, unknown, ThrowOnError>({
        url: '/v1/asset-groups:batchGet',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const assetGroupServiceCreateAssetGroupFromRawBytes = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceCreateAssetGroupFromRawBytesData, ThrowOnError>) => {
    return (options.client ?? client).post<AssetGroupServiceCreateAssetGroupFromRawBytesResponses, unknown, ThrowOnError>({
        url: '/v1/asset-groups:fromRawBytes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const assetGroupServiceCreateAssetGroupFromZip = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceCreateAssetGroupFromZipData, ThrowOnError>) => {
    return (options.client ?? client).post<AssetGroupServiceCreateAssetGroupFromZipResponses, unknown, ThrowOnError>({
        url: '/v1/asset-groups:fromZip',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Change password
 */
export const authServiceChangePassword = <ThrowOnError extends boolean = false>(options: Options<AuthServiceChangePasswordData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceChangePasswordResponses, unknown, ThrowOnError>({
        url: '/v1/auth/change-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const vendorInvitationServiceResolveInvitation = <ThrowOnError extends boolean = false>(options: Options<VendorInvitationServiceResolveInvitationData, ThrowOnError>) => {
    return (options.client ?? client).post<VendorInvitationServiceResolveInvitationResponses, unknown, ThrowOnError>({
        url: '/v1/auth/invitations/resolve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Login with email and password
 */
export const authServiceLogin = <ThrowOnError extends boolean = false>(options: Options<AuthServiceLoginData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceLoginResponses, unknown, ThrowOnError>({
        url: '/v1/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Logout (optional, mainly for token invalidation)
 */
export const authServiceLogout = <ThrowOnError extends boolean = false>(options: Options<AuthServiceLogoutData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceLogoutResponses, unknown, ThrowOnError>({
        url: '/v1/auth/logout',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get current user information
 */
export const authServiceGetMe = <ThrowOnError extends boolean = false>(options?: Options<AuthServiceGetMeData, ThrowOnError>) => {
    return (options?.client ?? client).get<AuthServiceGetMeResponses, unknown, ThrowOnError>({
        url: '/v1/auth/me',
        ...options
    });
};

/**
 * Complete a browser-bound WorkOS authorization code exchange.
 */
export const authServiceCompleteOAuth = <ThrowOnError extends boolean = false>(options: Options<AuthServiceCompleteOAuthData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceCompleteOAuthResponses, unknown, ThrowOnError>({
        url: '/v1/auth/oauth/complete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Start a browser-bound WorkOS social login.
 */
export const authServiceStartOAuth = <ThrowOnError extends boolean = false>(options: Options<AuthServiceStartOAuthData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceStartOAuthResponses, unknown, ThrowOnError>({
        url: '/v1/auth/oauth/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Reset password using verification code
 */
export const authServiceResetPassword = <ThrowOnError extends boolean = false>(options: Options<AuthServiceResetPasswordData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceResetPasswordResponses, unknown, ThrowOnError>({
        url: '/v1/auth/password-reset/reset',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update user profile
 */
export const authServiceUpdateProfile = <ThrowOnError extends boolean = false>(options: Options<AuthServiceUpdateProfileData, ThrowOnError>) => {
    return (options.client ?? client).put<AuthServiceUpdateProfileResponses, unknown, ThrowOnError>({
        url: '/v1/auth/profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Register a new user with email and password
 */
export const authServiceRegister = <ThrowOnError extends boolean = false>(options: Options<AuthServiceRegisterData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceRegisterResponses, unknown, ThrowOnError>({
        url: '/v1/auth/register',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const vendorInvitationServiceGetMyVendor = <ThrowOnError extends boolean = false>(options?: Options<VendorInvitationServiceGetMyVendorData, ThrowOnError>) => {
    return (options?.client ?? client).get<VendorInvitationServiceGetMyVendorResponses, unknown, ThrowOnError>({
        url: '/v1/auth/vendor',
        ...options
    });
};

/**
 * Send an email verification code
 */
export const authServiceSendVerificationCode = <ThrowOnError extends boolean = false>(options: Options<AuthServiceSendVerificationCodeData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceSendVerificationCodeResponses, unknown, ThrowOnError>({
        url: '/v1/auth/verification-code/send',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Verify an email verification code
 */
export const authServiceVerifyVerificationCode = <ThrowOnError extends boolean = false>(options: Options<AuthServiceVerifyVerificationCodeData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceVerifyVerificationCodeResponses, unknown, ThrowOnError>({
        url: '/v1/auth/verification-code/verify',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const assetGroupServiceListAvatarModelProfiles = <ThrowOnError extends boolean = false>(options?: Options<AssetGroupServiceListAvatarModelProfilesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AssetGroupServiceListAvatarModelProfilesResponses, unknown, ThrowOnError>({
        url: '/v1/avatar-model-profiles',
        ...options
    });
};

export const assetGroupServiceCreateAvatarModelProfile = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceCreateAvatarModelProfileData, ThrowOnError>) => {
    return (options.client ?? client).post<AssetGroupServiceCreateAvatarModelProfileResponses, unknown, ThrowOnError>({
        url: '/v1/avatar-model-profiles',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const assetGroupServiceGetAvatarModelProfile = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceGetAvatarModelProfileData, ThrowOnError>) => {
    return (options.client ?? client).get<AssetGroupServiceGetAvatarModelProfileResponses, unknown, ThrowOnError>({
        url: '/v1/avatar-model-profiles/{key}',
        ...options
    });
};

export const assetGroupServiceUpdateAvatarModelProfile = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceUpdateAvatarModelProfileData, ThrowOnError>) => {
    return (options.client ?? client).put<AssetGroupServiceUpdateAvatarModelProfileResponses, unknown, ThrowOnError>({
        url: '/v1/avatar-model-profiles/{key}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const assetGroupServiceDeprecateAvatarModelProfile = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceDeprecateAvatarModelProfileData, ThrowOnError>) => {
    return (options.client ?? client).post<AssetGroupServiceDeprecateAvatarModelProfileResponses, unknown, ThrowOnError>({
        url: '/v1/avatar-model-profiles/{key}:deprecate',
        ...options
    });
};

export const avatarServiceListAvatars = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListAvatarsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarServiceListAvatarsResponses, unknown, ThrowOnError>({
        url: '/v1/avatars',
        ...options
    });
};

export const avatarServiceCreateAvatar = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceCreateAvatarData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceCreateAvatarResponses, unknown, ThrowOnError>({
        url: '/v1/avatars',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const avatarServiceGetAvatarsByIds = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGetAvatarsByIdsData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceGetAvatarsByIdsResponses, unknown, ThrowOnError>({
        url: '/v1/avatars/batch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const avatarServiceCreateCustomAnimation = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceCreateCustomAnimationData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceCreateCustomAnimationResponses, unknown, ThrowOnError>({
        url: '/v1/avatars/{avatarId}/custom-animations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const avatarServiceUpdateCustomAnimation = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceUpdateCustomAnimationData, ThrowOnError>) => {
    return (options.client ?? client).patch<AvatarServiceUpdateCustomAnimationResponses, unknown, ThrowOnError>({
        url: '/v1/avatars/{avatarId}/custom-animations/{currentKey}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const avatarServiceRemoveCustomAnimation = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceRemoveCustomAnimationData, ThrowOnError>) => {
    return (options.client ?? client).delete<AvatarServiceRemoveCustomAnimationResponses, unknown, ThrowOnError>({
        url: '/v1/avatars/{avatarId}/custom-animations/{key}',
        ...options
    });
};

export const avatarServiceGetAvatarFilePresignedPutUrl = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGetAvatarFilePresignedPutUrlData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceGetAvatarFilePresignedPutUrlResponses, unknown, ThrowOnError>({
        url: '/v1/avatars/{avatarId}/files:presignedPutUrl',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const avatarServiceGenerateRawShapeData = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGenerateRawShapeDataData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceGenerateRawShapeDataResponses, unknown, ThrowOnError>({
        url: '/v1/avatars/{avatarId}/generate-raw-shape-data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const avatarServiceGenerateStyleData = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGenerateStyleDataData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceGenerateStyleDataResponses, unknown, ThrowOnError>({
        url: '/v1/avatars/{avatarId}/generate-style-data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const avatarServiceGenAnimation = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGenAnimationData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceGenAnimationResponses, unknown, ThrowOnError>({
        url: '/v1/avatars/{avatarId}:genAnimation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const avatarServiceDeleteAvatar = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceDeleteAvatarData, ThrowOnError>) => {
    return (options.client ?? client).delete<AvatarServiceDeleteAvatarResponses, unknown, ThrowOnError>({
        url: '/v1/avatars/{id}',
        ...options
    });
};

export const avatarServiceGetAvatar = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGetAvatarData, ThrowOnError>) => {
    return (options.client ?? client).get<AvatarServiceGetAvatarResponses, unknown, ThrowOnError>({
        url: '/v1/avatars/{id}',
        ...options
    });
};

export const avatarServiceUpdateAvatar = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceUpdateAvatarData, ThrowOnError>) => {
    return (options.client ?? client).patch<AvatarServiceUpdateAvatarResponses, unknown, ThrowOnError>({
        url: '/v1/avatars/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const avatarServiceCopyAvatar = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceCopyAvatarData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceCopyAvatarResponses, unknown, ThrowOnError>({
        url: '/v1/avatars/{id}/copy',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a short-lived browser authorization session for CLI login.
 */
export const cliAuthServiceCreateCliAuthSession = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceCreateCliAuthSessionData, ThrowOnError>) => {
    return (options.client ?? client).post<CliAuthServiceCreateCliAuthSessionResponses, unknown, ThrowOnError>({
        url: '/v1/cli/auth/sessions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieve session details for the open-platform-web authorization page.
 */
export const cliAuthServiceGetCliAuthSession = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceGetCliAuthSessionData, ThrowOnError>) => {
    return (options.client ?? client).get<CliAuthServiceGetCliAuthSessionResponses, unknown, ThrowOnError>({
        url: '/v1/cli/auth/sessions/{authRequestId}',
        ...options
    });
};

/**
 * Approve the session from the logged-in web page and produce the final loopback redirect URL.
 */
export const cliAuthServiceApproveCliAuthSession = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceApproveCliAuthSessionData, ThrowOnError>) => {
    return (options.client ?? client).post<CliAuthServiceApproveCliAuthSessionResponses, unknown, ThrowOnError>({
        url: '/v1/cli/auth/sessions/{authRequestId}:approve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Exchange auth code plus PKCE verifier for CLI tokens.
 */
export const cliAuthServiceExchangeCliAuthToken = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceExchangeCliAuthTokenData, ThrowOnError>) => {
    return (options.client ?? client).post<CliAuthServiceExchangeCliAuthTokenResponses, unknown, ThrowOnError>({
        url: '/v1/cli/auth/token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Refresh an expired access token by refresh token.
 */
export const cliAuthServiceRefreshCliAuthToken = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceRefreshCliAuthTokenData, ThrowOnError>) => {
    return (options.client ?? client).post<CliAuthServiceRefreshCliAuthTokenResponses, unknown, ThrowOnError>({
        url: '/v1/cli/auth/token:refresh',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Revoke CLI tokens during logout.
 */
export const cliAuthServiceRevokeCliAuthToken = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceRevokeCliAuthTokenData, ThrowOnError>) => {
    return (options.client ?? client).post<CliAuthServiceRevokeCliAuthTokenResponses, unknown, ThrowOnError>({
        url: '/v1/cli/auth/token:revoke',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const collectionTaskServiceListCollectionTasks = <ThrowOnError extends boolean = false>(options?: Options<CollectionTaskServiceListCollectionTasksData, ThrowOnError>) => {
    return (options?.client ?? client).get<CollectionTaskServiceListCollectionTasksResponses, unknown, ThrowOnError>({
        url: '/v1/console/collection-tasks',
        ...options
    });
};

/**
 * CollectionTask operations
 */
export const collectionTaskServiceCreateCollectionTask = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceCreateCollectionTaskData, ThrowOnError>) => {
    return (options.client ?? client).post<CollectionTaskServiceCreateCollectionTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/collection-tasks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const collectionTaskServiceDeleteCollectionTask = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceDeleteCollectionTaskData, ThrowOnError>) => {
    return (options.client ?? client).delete<CollectionTaskServiceDeleteCollectionTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/collection-tasks/{id}',
        ...options
    });
};

export const collectionTaskServiceGetCollectionTask = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceGetCollectionTaskData, ThrowOnError>) => {
    return (options.client ?? client).get<CollectionTaskServiceGetCollectionTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/collection-tasks/{id}',
        ...options
    });
};

export const collectionTaskServiceUpdateCollectionTask = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceUpdateCollectionTaskData, ThrowOnError>) => {
    return (options.client ?? client).put<CollectionTaskServiceUpdateCollectionTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/collection-tasks/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取容器镜像列表
 */
export const instanceManagementServiceListContainerImages = <ThrowOnError extends boolean = false>(options?: Options<InstanceManagementServiceListContainerImagesData, ThrowOnError>) => {
    return (options?.client ?? client).get<InstanceManagementServiceListContainerImagesResponses, unknown, ThrowOnError>({
        url: '/v1/console/container-images',
        ...options
    });
};

/**
 * 获取容器镜像标签列表
 */
export const instanceManagementServiceListContainerImageTags = <ThrowOnError extends boolean = false>(options: Options<InstanceManagementServiceListContainerImageTagsData, ThrowOnError>) => {
    return (options.client ?? client).get<InstanceManagementServiceListContainerImageTagsResponses, unknown, ThrowOnError>({
        url: '/v1/console/container-images/{namespace}/{repositoryName}/tags',
        ...options
    });
};

/**
 * List current iframe version configurations.
 */
export const iframeVersionServiceListIframeVersions = <ThrowOnError extends boolean = false>(options?: Options<IframeVersionServiceListIframeVersionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<IframeVersionServiceListIframeVersionsResponses, unknown, ThrowOnError>({
        url: '/v1/console/iframe-versions',
        ...options
    });
};

/**
 * 获取实例列表
 */
export const instanceManagementServiceListInstances = <ThrowOnError extends boolean = false>(options?: Options<InstanceManagementServiceListInstancesData, ThrowOnError>) => {
    return (options?.client ?? client).get<InstanceManagementServiceListInstancesResponses, unknown, ThrowOnError>({
        url: '/v1/console/instances',
        ...options
    });
};

/**
 * 获取启动模板列表
 */
export const instanceManagementServiceListLaunchTemplates = <ThrowOnError extends boolean = false>(options?: Options<InstanceManagementServiceListLaunchTemplatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<InstanceManagementServiceListLaunchTemplatesResponses, unknown, ThrowOnError>({
        url: '/v1/console/launch-templates',
        ...options
    });
};

export const materialServiceListMaterials = <ThrowOnError extends boolean = false>(options?: Options<MaterialServiceListMaterialsData, ThrowOnError>) => {
    return (options?.client ?? client).get<MaterialServiceListMaterialsResponses, unknown, ThrowOnError>({
        url: '/v1/console/materials',
        ...options
    });
};

export const materialServiceCreateMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceCreateMaterialData, ThrowOnError>) => {
    return (options.client ?? client).post<MaterialServiceCreateMaterialResponses, unknown, ThrowOnError>({
        url: '/v1/console/materials',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const materialServiceDeleteMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceDeleteMaterialData, ThrowOnError>) => {
    return (options.client ?? client).delete<MaterialServiceDeleteMaterialResponses, unknown, ThrowOnError>({
        url: '/v1/console/materials/{id}',
        ...options
    });
};

export const materialServiceGetMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceGetMaterialData, ThrowOnError>) => {
    return (options.client ?? client).get<MaterialServiceGetMaterialResponses, unknown, ThrowOnError>({
        url: '/v1/console/materials/{id}',
        ...options
    });
};

export const materialServiceUpdateMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceUpdateMaterialData, ThrowOnError>) => {
    return (options.client ?? client).put<MaterialServiceUpdateMaterialResponses, unknown, ThrowOnError>({
        url: '/v1/console/materials/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const materialServiceAdjustMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceAdjustMaterialData, ThrowOnError>) => {
    return (options.client ?? client).post<MaterialServiceAdjustMaterialResponses, unknown, ThrowOnError>({
        url: '/v1/console/materials/{id}/adjust',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const consoleServiceGetOssCredentials = <ThrowOnError extends boolean = false>(options: Options<ConsoleServiceGetOssCredentialsData, ThrowOnError>) => {
    return (options.client ?? client).post<ConsoleServiceGetOssCredentialsResponses, unknown, ThrowOnError>({
        url: '/v1/console/oss-credentials',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const pipeTemplateServiceListPipeTemplates = <ThrowOnError extends boolean = false>(options?: Options<PipeTemplateServiceListPipeTemplatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<PipeTemplateServiceListPipeTemplatesResponses, unknown, ThrowOnError>({
        url: '/v1/console/pipe-templates',
        ...options
    });
};

export const pipeTemplateServiceCreatePipeTemplate = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceCreatePipeTemplateData, ThrowOnError>) => {
    return (options.client ?? client).post<PipeTemplateServiceCreatePipeTemplateResponses, unknown, ThrowOnError>({
        url: '/v1/console/pipe-templates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const pipeTemplateServiceListTrackerVersions = <ThrowOnError extends boolean = false>(options?: Options<PipeTemplateServiceListTrackerVersionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<PipeTemplateServiceListTrackerVersionsResponses, unknown, ThrowOnError>({
        url: '/v1/console/pipe-templates/tracker-versions',
        ...options
    });
};

export const pipeTemplateServiceDeletePipeTemplate = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceDeletePipeTemplateData, ThrowOnError>) => {
    return (options.client ?? client).delete<PipeTemplateServiceDeletePipeTemplateResponses, unknown, ThrowOnError>({
        url: '/v1/console/pipe-templates/{id}',
        ...options
    });
};

export const pipeTemplateServiceGetPipeTemplate = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceGetPipeTemplateData, ThrowOnError>) => {
    return (options.client ?? client).get<PipeTemplateServiceGetPipeTemplateResponses, unknown, ThrowOnError>({
        url: '/v1/console/pipe-templates/{id}',
        ...options
    });
};

export const pipeTemplateServiceUpdatePipeTemplate = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceUpdatePipeTemplateData, ThrowOnError>) => {
    return (options.client ?? client).put<PipeTemplateServiceUpdatePipeTemplateResponses, unknown, ThrowOnError>({
        url: '/v1/console/pipe-templates/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const consoleServiceCreateSessionToken = <ThrowOnError extends boolean = false>(options: Options<ConsoleServiceCreateSessionTokenData, ThrowOnError>) => {
    return (options.client ?? client).post<ConsoleServiceCreateSessionTokenResponses, unknown, ThrowOnError>({
        url: '/v1/console/session-tokens',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const taskServiceListStatuses = <ThrowOnError extends boolean = false>(options?: Options<TaskServiceListStatusesData, ThrowOnError>) => {
    return (options?.client ?? client).get<TaskServiceListStatusesResponses, unknown, ThrowOnError>({
        url: '/v1/console/statuses',
        ...options
    });
};

/**
 * Status operations
 */
export const taskServiceCreateStatus = <ThrowOnError extends boolean = false>(options: Options<TaskServiceCreateStatusData, ThrowOnError>) => {
    return (options.client ?? client).post<TaskServiceCreateStatusResponses, unknown, ThrowOnError>({
        url: '/v1/console/statuses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const taskServiceDeleteStatus = <ThrowOnError extends boolean = false>(options: Options<TaskServiceDeleteStatusData, ThrowOnError>) => {
    return (options.client ?? client).delete<TaskServiceDeleteStatusResponses, unknown, ThrowOnError>({
        url: '/v1/console/statuses/{id}',
        ...options
    });
};

export const taskServiceGetStatus = <ThrowOnError extends boolean = false>(options: Options<TaskServiceGetStatusData, ThrowOnError>) => {
    return (options.client ?? client).get<TaskServiceGetStatusResponses, unknown, ThrowOnError>({
        url: '/v1/console/statuses/{id}',
        ...options
    });
};

export const taskServiceUpdateStatus = <ThrowOnError extends boolean = false>(options: Options<TaskServiceUpdateStatusData, ThrowOnError>) => {
    return (options.client ?? client).put<TaskServiceUpdateStatusResponses, unknown, ThrowOnError>({
        url: '/v1/console/statuses/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const taskServiceListTasks = <ThrowOnError extends boolean = false>(options?: Options<TaskServiceListTasksData, ThrowOnError>) => {
    return (options?.client ?? client).get<TaskServiceListTasksResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks',
        ...options
    });
};

/**
 * Task operations
 */
export const taskServiceCreateTask = <ThrowOnError extends boolean = false>(options: Options<TaskServiceCreateTaskData, ThrowOnError>) => {
    return (options.client ?? client).post<TaskServiceCreateTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get task statistics
 */
export const taskServiceGetTaskStats = <ThrowOnError extends boolean = false>(options?: Options<TaskServiceGetTaskStatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<TaskServiceGetTaskStatsResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks/stats',
        ...options
    });
};

export const taskServiceDeleteTask = <ThrowOnError extends boolean = false>(options: Options<TaskServiceDeleteTaskData, ThrowOnError>) => {
    return (options.client ?? client).delete<TaskServiceDeleteTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks/{id}',
        ...options
    });
};

export const taskServiceGetTask = <ThrowOnError extends boolean = false>(options: Options<TaskServiceGetTaskData, ThrowOnError>) => {
    return (options.client ?? client).get<TaskServiceGetTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks/{id}',
        ...options
    });
};

export const taskServiceUpdateTask = <ThrowOnError extends boolean = false>(options: Options<TaskServiceUpdateTaskData, ThrowOnError>) => {
    return (options.client ?? client).put<TaskServiceUpdateTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Terminate task instances
 */
export const taskServiceTerminateTaskInstances = <ThrowOnError extends boolean = false>(options: Options<TaskServiceTerminateTaskInstancesData, ThrowOnError>) => {
    return (options.client ?? client).post<TaskServiceTerminateTaskInstancesResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks/{id}/terminate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const drivingModelServiceListDrivingModels = <ThrowOnError extends boolean = false>(options?: Options<DrivingModelServiceListDrivingModelsData, ThrowOnError>) => {
    return (options?.client ?? client).get<DrivingModelServiceListDrivingModelsResponses, unknown, ThrowOnError>({
        url: '/v1/driving-models',
        ...options
    });
};

export const drivingModelServiceCreateDrivingModel = <ThrowOnError extends boolean = false>(options: Options<DrivingModelServiceCreateDrivingModelData, ThrowOnError>) => {
    return (options.client ?? client).post<DrivingModelServiceCreateDrivingModelResponses, unknown, ThrowOnError>({
        url: '/v1/driving-models',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const drivingModelServiceDeleteDrivingModel = <ThrowOnError extends boolean = false>(options: Options<DrivingModelServiceDeleteDrivingModelData, ThrowOnError>) => {
    return (options.client ?? client).delete<DrivingModelServiceDeleteDrivingModelResponses, unknown, ThrowOnError>({
        url: '/v1/driving-models/{id}',
        ...options
    });
};

export const drivingModelServiceGetDrivingModel = <ThrowOnError extends boolean = false>(options: Options<DrivingModelServiceGetDrivingModelData, ThrowOnError>) => {
    return (options.client ?? client).get<DrivingModelServiceGetDrivingModelResponses, unknown, ThrowOnError>({
        url: '/v1/driving-models/{id}',
        ...options
    });
};

export const drivingModelServiceUpdateDrivingModel = <ThrowOnError extends boolean = false>(options: Options<DrivingModelServiceUpdateDrivingModelData, ThrowOnError>) => {
    return (options.client ?? client).patch<DrivingModelServiceUpdateDrivingModelResponses, unknown, ThrowOnError>({
        url: '/v1/driving-models/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const assetGroupServiceCreateGenericAssetGroup = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceCreateGenericAssetGroupData, ThrowOnError>) => {
    return (options.client ?? client).post<AssetGroupServiceCreateGenericAssetGroupResponses, unknown, ThrowOnError>({
        url: '/v1/generic-asset-groups',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const assetGroupServiceGetGenericAssetGroup = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceGetGenericAssetGroupData, ThrowOnError>) => {
    return (options.client ?? client).get<AssetGroupServiceGetGenericAssetGroupResponses, unknown, ThrowOnError>({
        url: '/v1/generic-asset-groups/{id}',
        ...options
    });
};

/**
 * GetRegionStats returns this region's real-time stats from local driven-ingress
 * Called by other regions' Console to fetch local stats
 */
export const drivenStatsServiceGetRegionStats = <ThrowOnError extends boolean = false>(options?: Options<DrivenStatsServiceGetRegionStatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<DrivenStatsServiceGetRegionStatsResponses, unknown, ThrowOnError>({
        url: '/v1/internal/driven-stats/region',
        ...options
    });
};

/**
 * SyncDrivenStats syncs usage and concurrency stats from remote regions to the primary database
 * This endpoint is called by remote region backup jobs
 */
export const drivenStatsServiceSyncDrivenStats = <ThrowOnError extends boolean = false>(options: Options<DrivenStatsServiceSyncDrivenStatsData, ThrowOnError>) => {
    return (options.client ?? client).post<DrivenStatsServiceSyncDrivenStatsResponses, unknown, ThrowOnError>({
        url: '/v1/internal/driven-stats/sync',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const avatarServiceListAvatarJobs = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListAvatarJobsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarServiceListAvatarJobsResponses, unknown, ThrowOnError>({
        url: '/v1/open/avatar-jobs',
        ...options
    });
};

export const avatarServiceGetAvatarJob = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGetAvatarJobData, ThrowOnError>) => {
    return (options.client ?? client).get<AvatarServiceGetAvatarJobResponses, unknown, ThrowOnError>({
        url: '/v1/open/avatar-jobs/{jobId}',
        ...options
    });
};

export const avatarServiceListAvatars2 = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListAvatars2Data, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarServiceListAvatars2Responses, unknown, ThrowOnError>({
        url: '/v1/open/avatars',
        ...options
    });
};

export const avatarServiceCreateAvatar2 = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceCreateAvatar2Data, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceCreateAvatar2Responses, unknown, ThrowOnError>({
        url: '/v1/open/avatars',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const avatarServiceGetAvatar2 = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGetAvatar2Data, ThrowOnError>) => {
    return (options.client ?? client).get<AvatarServiceGetAvatar2Responses, unknown, ThrowOnError>({
        url: '/v1/open/avatars/{avatarId}',
        ...options
    });
};

export const videoServiceListVideoJobs = <ThrowOnError extends boolean = false>(options?: Options<VideoServiceListVideoJobsData, ThrowOnError>) => {
    return (options?.client ?? client).get<VideoServiceListVideoJobsResponses, unknown, ThrowOnError>({
        url: '/v1/open/video-jobs',
        ...options
    });
};

export const videoServiceGetVideoJob = <ThrowOnError extends boolean = false>(options: Options<VideoServiceGetVideoJobData, ThrowOnError>) => {
    return (options.client ?? client).get<VideoServiceGetVideoJobResponses, unknown, ThrowOnError>({
        url: '/v1/open/video-jobs/{jobId}',
        ...options
    });
};

export const videoServiceCreateVideo = <ThrowOnError extends boolean = false>(options: Options<VideoServiceCreateVideoData, ThrowOnError>) => {
    return (options.client ?? client).post<VideoServiceCreateVideoResponses, unknown, ThrowOnError>({
        url: '/v1/open/videos',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get collection task by share token
 */
export const collectionTaskServiceGetCollectionTaskByToken = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceGetCollectionTaskByTokenData, ThrowOnError>) => {
    return (options.client ?? client).get<CollectionTaskServiceGetCollectionTaskByTokenResponses, unknown, ThrowOnError>({
        url: '/v1/public/collection-tasks/{token}',
        ...options
    });
};

/**
 * Get OSS credentials for file upload
 */
export const collectionTaskServiceGetCollectionTaskOssCredentials = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceGetCollectionTaskOssCredentialsData, ThrowOnError>) => {
    return (options.client ?? client).post<CollectionTaskServiceGetCollectionTaskOssCredentialsResponses, unknown, ThrowOnError>({
        url: '/v1/public/collection-tasks/{token}/oss-credentials',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Submit uploaded file and create material
 */
export const collectionTaskServiceSubmitCollectionFile = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceSubmitCollectionFileData, ThrowOnError>) => {
    return (options.client ?? client).post<CollectionTaskServiceSubmitCollectionFileResponses, unknown, ThrowOnError>({
        url: '/v1/public/collection-tasks/{token}/submit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const taskHeartbeatServiceHeartbeat = <ThrowOnError extends boolean = false>(options: Options<TaskHeartbeatServiceHeartbeatData, ThrowOnError>) => {
    return (options.client ?? client).post<TaskHeartbeatServiceHeartbeatResponses, unknown, ThrowOnError>({
        url: '/v1/task-heartbeat/{instanceId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const vendorAuthServiceCompleteLogin = <ThrowOnError extends boolean = false>(options: Options<VendorAuthServiceCompleteLoginData, ThrowOnError>) => {
    return (options.client ?? client).post<VendorAuthServiceCompleteLoginResponses, unknown, ThrowOnError>({
        url: '/v1/vendor/auth/complete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const vendorAuthServiceLogout = <ThrowOnError extends boolean = false>(options: Options<VendorAuthServiceLogoutData, ThrowOnError>) => {
    return (options.client ?? client).post<VendorAuthServiceLogoutResponses, unknown, ThrowOnError>({
        url: '/v1/vendor/auth/logout',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const vendorAuthServiceGetMe = <ThrowOnError extends boolean = false>(options?: Options<VendorAuthServiceGetMeData, ThrowOnError>) => {
    return (options?.client ?? client).get<VendorAuthServiceGetMeResponses, unknown, ThrowOnError>({
        url: '/v1/vendor/auth/me',
        ...options
    });
};

export const vendorAuthServiceStartLogin = <ThrowOnError extends boolean = false>(options: Options<VendorAuthServiceStartLoginData, ThrowOnError>) => {
    return (options.client ?? client).post<VendorAuthServiceStartLoginResponses, unknown, ThrowOnError>({
        url: '/v1/vendor/auth/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const vendorServiceListCustomers = <ThrowOnError extends boolean = false>(options: Options<VendorServiceListCustomersData, ThrowOnError>) => {
    return (options.client ?? client).get<VendorServiceListCustomersResponses, unknown, ThrowOnError>({
        url: '/v1/vendor/vendors/{vendorId}/customers',
        ...options
    });
};

export const vendorServiceGetCustomer = <ThrowOnError extends boolean = false>(options: Options<VendorServiceGetCustomerData, ThrowOnError>) => {
    return (options.client ?? client).get<VendorServiceGetCustomerResponses, unknown, ThrowOnError>({
        url: '/v1/vendor/vendors/{vendorId}/customers/{customerId}',
        ...options
    });
};

export const vendorServiceListCustomerAvatars = <ThrowOnError extends boolean = false>(options: Options<VendorServiceListCustomerAvatarsData, ThrowOnError>) => {
    return (options.client ?? client).get<VendorServiceListCustomerAvatarsResponses, unknown, ThrowOnError>({
        url: '/v1/vendor/vendors/{vendorId}/customers/{customerId}/avatars',
        ...options
    });
};

export const vendorServiceListInvitations = <ThrowOnError extends boolean = false>(options: Options<VendorServiceListInvitationsData, ThrowOnError>) => {
    return (options.client ?? client).get<VendorServiceListInvitationsResponses, unknown, ThrowOnError>({
        url: '/v1/vendor/vendors/{vendorId}/invitations',
        ...options
    });
};

export const vendorServiceCreateInvitation = <ThrowOnError extends boolean = false>(options: Options<VendorServiceCreateInvitationData, ThrowOnError>) => {
    return (options.client ?? client).post<VendorServiceCreateInvitationResponses, unknown, ThrowOnError>({
        url: '/v1/vendor/vendors/{vendorId}/invitations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const vendorServiceGetInvitationLink = <ThrowOnError extends boolean = false>(options: Options<VendorServiceGetInvitationLinkData, ThrowOnError>) => {
    return (options.client ?? client).get<VendorServiceGetInvitationLinkResponses, unknown, ThrowOnError>({
        url: '/v1/vendor/vendors/{vendorId}/invitations/{invitationId}/link',
        ...options
    });
};

export const vendorServiceRevokeInvitation = <ThrowOnError extends boolean = false>(options: Options<VendorServiceRevokeInvitationData, ThrowOnError>) => {
    return (options.client ?? client).post<VendorServiceRevokeInvitationResponses, unknown, ThrowOnError>({
        url: '/v1/vendor/vendors/{vendorId}/invitations/{invitationId}/revoke',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminAnnouncementServiceAdminListAnnouncementTemplates = <ThrowOnError extends boolean = false>(options?: Options<AdminAnnouncementServiceAdminListAnnouncementTemplatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAnnouncementServiceAdminListAnnouncementTemplatesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/announcement-templates',
        ...options
    });
};

export const adminAnnouncementServiceAdminCreateAnnouncementTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminAnnouncementServiceAdminCreateAnnouncementTemplateData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAnnouncementServiceAdminCreateAnnouncementTemplateResponses, unknown, ThrowOnError>({
        url: '/v2/admin/announcement-templates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminAnnouncementServiceAdminDeleteAnnouncementTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminAnnouncementServiceAdminDeleteAnnouncementTemplateData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminAnnouncementServiceAdminDeleteAnnouncementTemplateResponses, unknown, ThrowOnError>({
        url: '/v2/admin/announcement-templates/{id}',
        ...options
    });
};

export const adminAnnouncementServiceAdminUpdateAnnouncementTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminAnnouncementServiceAdminUpdateAnnouncementTemplateData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminAnnouncementServiceAdminUpdateAnnouncementTemplateResponses, unknown, ThrowOnError>({
        url: '/v2/admin/announcement-templates/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fills a template with values and returns the announcement payload without storing it.
 */
export const adminAnnouncementServiceAdminRenderAnnouncementTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminAnnouncementServiceAdminRenderAnnouncementTemplateData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAnnouncementServiceAdminRenderAnnouncementTemplateResponses, unknown, ThrowOnError>({
        url: '/v2/admin/announcement-templates/{id}:render',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminAnnouncementServiceAdminListAnnouncements = <ThrowOnError extends boolean = false>(options?: Options<AdminAnnouncementServiceAdminListAnnouncementsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAnnouncementServiceAdminListAnnouncementsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/announcements',
        ...options
    });
};

export const adminAnnouncementServiceAdminCreateAnnouncement = <ThrowOnError extends boolean = false>(options: Options<AdminAnnouncementServiceAdminCreateAnnouncementData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAnnouncementServiceAdminCreateAnnouncementResponses, unknown, ThrowOnError>({
        url: '/v2/admin/announcements',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Updates title / body. Allowed for drafts and published announcements alike.
 */
export const adminAnnouncementServiceAdminUpdateAnnouncement = <ThrowOnError extends boolean = false>(options: Options<AdminAnnouncementServiceAdminUpdateAnnouncementData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminAnnouncementServiceAdminUpdateAnnouncementResponses, unknown, ThrowOnError>({
        url: '/v2/admin/announcements/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Publishes or unpublishes an announcement.
 */
export const adminAnnouncementServiceAdminSetAnnouncementPublished = <ThrowOnError extends boolean = false>(options: Options<AdminAnnouncementServiceAdminSetAnnouncementPublishedData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAnnouncementServiceAdminSetAnnouncementPublishedResponses, unknown, ThrowOnError>({
        url: '/v2/admin/announcements/{id}:set-published',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all avatar applies with user information
 */
export const adminAvatarApplyServiceAdminListAvatarApplies = <ThrowOnError extends boolean = false>(options?: Options<AdminAvatarApplyServiceAdminListAvatarAppliesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAvatarApplyServiceAdminListAvatarAppliesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-applies',
        ...options
    });
};

/**
 * Delete an avatar apply record
 */
export const adminAvatarApplyServiceAdminDeleteAvatarApply = <ThrowOnError extends boolean = false>(options: Options<AdminAvatarApplyServiceAdminDeleteAvatarApplyData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminAvatarApplyServiceAdminDeleteAvatarApplyResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-applies/{id}',
        ...options
    });
};

export const adminConsoleAvatarListServiceListConsoleAvatarLists = <ThrowOnError extends boolean = false>(options?: Options<AdminConsoleAvatarListServiceListConsoleAvatarListsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminConsoleAvatarListServiceListConsoleAvatarListsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-lists',
        ...options
    });
};

export const adminConsoleAvatarListServiceCreateConsoleAvatarList = <ThrowOnError extends boolean = false>(options: Options<AdminConsoleAvatarListServiceCreateConsoleAvatarListData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminConsoleAvatarListServiceCreateConsoleAvatarListResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-lists',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminConsoleAvatarListServiceDeleteConsoleAvatarList = <ThrowOnError extends boolean = false>(options: Options<AdminConsoleAvatarListServiceDeleteConsoleAvatarListData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminConsoleAvatarListServiceDeleteConsoleAvatarListResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-lists/{id}',
        ...options
    });
};

export const adminConsoleAvatarListServiceGetConsoleAvatarList = <ThrowOnError extends boolean = false>(options: Options<AdminConsoleAvatarListServiceGetConsoleAvatarListData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminConsoleAvatarListServiceGetConsoleAvatarListResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-lists/{id}',
        ...options
    });
};

export const adminConsoleAvatarListServiceUpdateConsoleAvatarList = <ThrowOnError extends boolean = false>(options: Options<AdminConsoleAvatarListServiceUpdateConsoleAvatarListData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminConsoleAvatarListServiceUpdateConsoleAvatarListResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-lists/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 手动发放 Units
 */
export const adminAvatarUnitServiceGrantAvatarUnits = <ThrowOnError extends boolean = false>(options: Options<AdminAvatarUnitServiceGrantAvatarUnitsData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAvatarUnitServiceGrantAvatarUnitsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-units/grant',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 查询 grant 列表
 */
export const adminAvatarUnitServiceListAvatarUnitGrants = <ThrowOnError extends boolean = false>(options?: Options<AdminAvatarUnitServiceListAvatarUnitGrantsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAvatarUnitServiceListAvatarUnitGrantsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-units/grants',
        ...options
    });
};

export const adminAvatarUnitServiceListAvatarUnitPackages = <ThrowOnError extends boolean = false>(options?: Options<AdminAvatarUnitServiceListAvatarUnitPackagesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAvatarUnitServiceListAvatarUnitPackagesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-units/packages',
        ...options
    });
};

export const adminAvatarUnitServiceCreateAvatarUnitPackage = <ThrowOnError extends boolean = false>(options: Options<AdminAvatarUnitServiceCreateAvatarUnitPackageData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAvatarUnitServiceCreateAvatarUnitPackageResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-units/packages',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminAvatarUnitServiceDeleteAvatarUnitPackage = <ThrowOnError extends boolean = false>(options: Options<AdminAvatarUnitServiceDeleteAvatarUnitPackageData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminAvatarUnitServiceDeleteAvatarUnitPackageResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-units/packages/{packageId}',
        ...options
    });
};

export const adminAvatarUnitServiceUpdateAvatarUnitPackage = <ThrowOnError extends boolean = false>(options: Options<AdminAvatarUnitServiceUpdateAvatarUnitPackageData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminAvatarUnitServiceUpdateAvatarUnitPackageResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-units/packages/{packageId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminAvatarUnitServiceListAvatarPipelines = <ThrowOnError extends boolean = false>(options?: Options<AdminAvatarUnitServiceListAvatarPipelinesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAvatarUnitServiceListAvatarPipelinesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-units/pipelines',
        ...options
    });
};

export const adminAvatarUnitServiceCreateAvatarPipeline = <ThrowOnError extends boolean = false>(options: Options<AdminAvatarUnitServiceCreateAvatarPipelineData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAvatarUnitServiceCreateAvatarPipelineResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-units/pipelines',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminAvatarUnitServiceDeleteAvatarPipeline = <ThrowOnError extends boolean = false>(options: Options<AdminAvatarUnitServiceDeleteAvatarPipelineData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminAvatarUnitServiceDeleteAvatarPipelineResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-units/pipelines/{pipelineId}',
        ...options
    });
};

export const adminAvatarUnitServiceUpdateAvatarPipeline = <ThrowOnError extends boolean = false>(options: Options<AdminAvatarUnitServiceUpdateAvatarPipelineData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminAvatarUnitServiceUpdateAvatarPipelineResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-units/pipelines/{pipelineId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 查询流水（全局）
 */
export const adminAvatarUnitServiceListAvatarUnitTransactions = <ThrowOnError extends boolean = false>(options?: Options<AdminAvatarUnitServiceListAvatarUnitTransactionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAvatarUnitServiceListAvatarUnitTransactionsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-units/transactions',
        ...options
    });
};

/**
 * 查询指定用户的 Unit 余额
 */
export const adminAvatarUnitServiceGetUserAvatarUnitBalance = <ThrowOnError extends boolean = false>(options: Options<AdminAvatarUnitServiceGetUserAvatarUnitBalanceData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminAvatarUnitServiceGetUserAvatarUnitBalanceResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-units/users/{userId}/balance',
        ...options
    });
};

/**
 * 获取所有充值包（包含未上架的）
 */
export const adminBillingServiceListCreditPackages = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceListCreditPackagesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminBillingServiceListCreditPackagesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credit-packages',
        ...options
    });
};

/**
 * 创建充值包
 */
export const adminBillingServiceCreateCreditPackage = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceCreateCreditPackageData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminBillingServiceCreateCreditPackageResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credit-packages',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除充值包（软删除）
 */
export const adminBillingServiceDeleteCreditPackage = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceDeleteCreditPackageData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminBillingServiceDeleteCreditPackageResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credit-packages/{packageId}',
        ...options
    });
};

/**
 * 更新充值包
 */
export const adminBillingServiceUpdateCreditPackage = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceUpdateCreditPackageData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminBillingServiceUpdateCreditPackageResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credit-packages/{packageId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 扣减用户 Credits
 */
export const adminBillingServiceDeductCredits = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceDeductCreditsData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminBillingServiceDeductCreditsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credits/deduct',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 赠送 Credits 给用户
 */
export const adminBillingServiceGrantCredits = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceGrantCreditsData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminBillingServiceGrantCreditsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credits/grant',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取所有 Credits 流水（支持 user_id / type 筛选）
 */
export const adminBillingServiceListCreditTransactions = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceListCreditTransactionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminBillingServiceListCreditTransactionsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credits/transactions',
        ...options
    });
};

/**
 * 获取所有订阅计划（包含非公开的）
 */
export const adminBillingServiceListPlans = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceListPlansData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminBillingServiceListPlansResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/plans',
        ...options
    });
};

/**
 * 创建订阅计划
 */
export const adminBillingServiceCreatePlan = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceCreatePlanData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminBillingServiceCreatePlanResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/plans',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除订阅计划（软删除）
 */
export const adminBillingServiceDeletePlan = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceDeletePlanData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminBillingServiceDeletePlanResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/plans/{planId}',
        ...options
    });
};

/**
 * 获取单个订阅计划详情
 */
export const adminBillingServiceGetPlan = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceGetPlanData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminBillingServiceGetPlanResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/plans/{planId}',
        ...options
    });
};

/**
 * 更新订阅计划
 */
export const adminBillingServiceUpdatePlan = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceUpdatePlanData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminBillingServiceUpdatePlanResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/plans/{planId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取计费统计概览
 */
export const adminBillingServiceGetBillingStats = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceGetBillingStatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminBillingServiceGetBillingStatsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/stats',
        ...options
    });
};

/**
 * 获取所有用户订阅列表
 */
export const adminBillingServiceListSubscriptions = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceListSubscriptionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminBillingServiceListSubscriptionsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/subscriptions',
        ...options
    });
};

/**
 * 获取用户 Credits 余额
 */
export const adminBillingServiceGetUserCreditBalance = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceGetUserCreditBalanceData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminBillingServiceGetUserCreditBalanceResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/users/{userId}/credits',
        ...options
    });
};

/**
 * 获取用户 Credits 交易记录
 */
export const adminBillingServiceListUserCreditTransactions = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceListUserCreditTransactionsData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminBillingServiceListUserCreditTransactionsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/users/{userId}/credits/transactions',
        ...options
    });
};

/**
 * 获取用户消费明细
 */
export const adminBillingServiceListUserCreditUsages = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceListUserCreditUsagesData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminBillingServiceListUserCreditUsagesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/users/{userId}/credits/usages',
        ...options
    });
};

/**
 * 获取指定用户的订阅信息
 */
export const adminBillingServiceGetUserSubscription = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceGetUserSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminBillingServiceGetUserSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/users/{userId}/subscription',
        ...options
    });
};

/**
 * 更新用户订阅（管理员强制变更）
 */
export const adminBillingServiceUpdateUserSubscription = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceUpdateUserSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminBillingServiceUpdateUserSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/users/{userId}/subscription',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminChatServiceAdminListChats = <ThrowOnError extends boolean = false>(options?: Options<AdminChatServiceAdminListChatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminChatServiceAdminListChatsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/chats',
        ...options
    });
};

/**
 * Starts a chat with a user, optionally linked to a feedback ticket.
 */
export const adminChatServiceAdminCreateChat = <ThrowOnError extends boolean = false>(options: Options<AdminChatServiceAdminCreateChatData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminChatServiceAdminCreateChatResponses, unknown, ThrowOnError>({
        url: '/v2/admin/chats',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminChatServiceAdminSendChatMessage = <ThrowOnError extends boolean = false>(options: Options<AdminChatServiceAdminSendChatMessageData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminChatServiceAdminSendChatMessageResponses, unknown, ThrowOnError>({
        url: '/v2/admin/chats/{chatId}/messages',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminChatServiceAdminGetChat = <ThrowOnError extends boolean = false>(options: Options<AdminChatServiceAdminGetChatData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminChatServiceAdminGetChatResponses, unknown, ThrowOnError>({
        url: '/v2/admin/chats/{id}',
        ...options
    });
};

/**
 * Closes a user's ticket on their behalf. Only tickets close; there is no
 * reopen, so operators should prefer asking the user to close it themselves.
 */
export const adminChatServiceAdminCloseChat = <ThrowOnError extends boolean = false>(options: Options<AdminChatServiceAdminCloseChatData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminChatServiceAdminCloseChatResponses, unknown, ThrowOnError>({
        url: '/v2/admin/chats/{id}:close',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminChatServiceAdminMarkChatRead = <ThrowOnError extends boolean = false>(options: Options<AdminChatServiceAdminMarkChatReadData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminChatServiceAdminMarkChatReadResponses, unknown, ThrowOnError>({
        url: '/v2/admin/chats/{id}:read',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get concurrency trend data
 */
export const adminDrivenStatsServiceGetConcurrencyTrend = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetConcurrencyTrendData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenStatsServiceGetConcurrencyTrendResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/concurrency-trend',
        ...options
    });
};

/**
 * Get detailed stats for a specific entity (region, app, or user)
 */
export const adminDrivenStatsServiceGetEntityStats = <ThrowOnError extends boolean = false>(options: Options<AdminDrivenStatsServiceGetEntityStatsData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminDrivenStatsServiceGetEntityStatsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/entity/{entityType}/{entityId}',
        ...options
    });
};

/**
 * Get overview statistics (top stat cards)
 */
export const adminDrivenStatsServiceGetOverview = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetOverviewData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenStatsServiceGetOverviewResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/overview',
        ...options
    });
};

/**
 * Get real-time stats from driveningress service
 */
export const adminDrivenStatsServiceGetRealtimeStats = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetRealtimeStatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenStatsServiceGetRealtimeStatsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/realtime',
        ...options
    });
};

/**
 * Get region distribution data (for pie chart)
 */
export const adminDrivenStatsServiceGetRegionDistribution = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetRegionDistributionData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenStatsServiceGetRegionDistributionResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/region-distribution',
        ...options
    });
};

/**
 * Get top users by usage
 */
export const adminDrivenStatsServiceGetTopUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetTopUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenStatsServiceGetTopUsersResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/top-users',
        ...options
    });
};

/**
 * Get usage trend data (time series)
 */
export const adminDrivenStatsServiceGetTrend = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetTrendData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenStatsServiceGetTrendResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/trend',
        ...options
    });
};

/**
 * Requires a Console administrator; does not use the caller's Studio identity.
 */
export const adminDrivenStatsServiceListConnectionLogs = <ThrowOnError extends boolean = false>(options: Options<AdminDrivenStatsServiceListConnectionLogsData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminDrivenStatsServiceListConnectionLogsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/users/{userId}/connection-logs',
        ...options
    });
};

export const adminEmailServiceAdminListEmailCategories = <ThrowOnError extends boolean = false>(options?: Options<AdminEmailServiceAdminListEmailCategoriesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminEmailServiceAdminListEmailCategoriesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/email-categories',
        ...options
    });
};

export const adminEmailServiceAdminCreateEmailCategory = <ThrowOnError extends boolean = false>(options: Options<AdminEmailServiceAdminCreateEmailCategoryData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminEmailServiceAdminCreateEmailCategoryResponses, unknown, ThrowOnError>({
        url: '/v2/admin/email-categories',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminEmailServiceAdminDeleteEmailCategory = <ThrowOnError extends boolean = false>(options: Options<AdminEmailServiceAdminDeleteEmailCategoryData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminEmailServiceAdminDeleteEmailCategoryResponses, unknown, ThrowOnError>({
        url: '/v2/admin/email-categories/{id}',
        ...options
    });
};

export const adminEmailServiceAdminUpdateEmailCategory = <ThrowOnError extends boolean = false>(options: Options<AdminEmailServiceAdminUpdateEmailCategoryData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminEmailServiceAdminUpdateEmailCategoryResponses, unknown, ThrowOnError>({
        url: '/v2/admin/email-categories/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminEmailServiceAdminListEmailCategoryUsages = <ThrowOnError extends boolean = false>(options: Options<AdminEmailServiceAdminListEmailCategoryUsagesData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminEmailServiceAdminListEmailCategoryUsagesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/email-categories/{id}:usages',
        ...options
    });
};

export const adminEmailServiceAdminListEmailTemplates = <ThrowOnError extends boolean = false>(options?: Options<AdminEmailServiceAdminListEmailTemplatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminEmailServiceAdminListEmailTemplatesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/email-templates',
        ...options
    });
};

export const adminEmailServiceAdminCreateEmailTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminEmailServiceAdminCreateEmailTemplateData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminEmailServiceAdminCreateEmailTemplateResponses, unknown, ThrowOnError>({
        url: '/v2/admin/email-templates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminEmailServiceAdminDeleteEmailTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminEmailServiceAdminDeleteEmailTemplateData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminEmailServiceAdminDeleteEmailTemplateResponses, unknown, ThrowOnError>({
        url: '/v2/admin/email-templates/{id}',
        ...options
    });
};

export const adminEmailServiceAdminUpdateEmailTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminEmailServiceAdminUpdateEmailTemplateData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminEmailServiceAdminUpdateEmailTemplateResponses, unknown, ThrowOnError>({
        url: '/v2/admin/email-templates/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminEmailServiceAdminRenderEmailTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminEmailServiceAdminRenderEmailTemplateData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminEmailServiceAdminRenderEmailTemplateResponses, unknown, ThrowOnError>({
        url: '/v2/admin/email-templates/{id}:render',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminEmailServiceAdminSendTestEmail = <ThrowOnError extends boolean = false>(options: Options<AdminEmailServiceAdminSendTestEmailData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminEmailServiceAdminSendTestEmailResponses, unknown, ThrowOnError>({
        url: '/v2/admin/email-templates/{id}:send-test',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminEmailServiceAdminListEmailTemplateUsages = <ThrowOnError extends boolean = false>(options: Options<AdminEmailServiceAdminListEmailTemplateUsagesData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminEmailServiceAdminListEmailTemplateUsagesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/email-templates/{id}:usages',
        ...options
    });
};

export const adminNotificationServiceAdminListNotificationRules = <ThrowOnError extends boolean = false>(options?: Options<AdminNotificationServiceAdminListNotificationRulesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminNotificationServiceAdminListNotificationRulesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notification-rules',
        ...options
    });
};

export const adminNotificationServiceAdminCreateNotificationRule = <ThrowOnError extends boolean = false>(options: Options<AdminNotificationServiceAdminCreateNotificationRuleData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminNotificationServiceAdminCreateNotificationRuleResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notification-rules',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminNotificationServiceAdminDeleteNotificationRule = <ThrowOnError extends boolean = false>(options: Options<AdminNotificationServiceAdminDeleteNotificationRuleData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminNotificationServiceAdminDeleteNotificationRuleResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notification-rules/{id}',
        ...options
    });
};

export const adminNotificationServiceAdminUpdateNotificationRule = <ThrowOnError extends boolean = false>(options: Options<AdminNotificationServiceAdminUpdateNotificationRuleData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminNotificationServiceAdminUpdateNotificationRuleResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notification-rules/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminNotificationServiceAdminSetNotificationRuleEnabled = <ThrowOnError extends boolean = false>(options: Options<AdminNotificationServiceAdminSetNotificationRuleEnabledData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminNotificationServiceAdminSetNotificationRuleEnabledResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notification-rules/{id}:set-enabled',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminNotificationServiceAdminListNotificationRuleFields = <ThrowOnError extends boolean = false>(options?: Options<AdminNotificationServiceAdminListNotificationRuleFieldsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminNotificationServiceAdminListNotificationRuleFieldsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notification-rules:fields',
        ...options
    });
};

export const adminNotificationServiceAdminPreviewNotificationRule = <ThrowOnError extends boolean = false>(options: Options<AdminNotificationServiceAdminPreviewNotificationRuleData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminNotificationServiceAdminPreviewNotificationRuleResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notification-rules:preview',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminNotificationServiceAdminListNotificationTemplates = <ThrowOnError extends boolean = false>(options?: Options<AdminNotificationServiceAdminListNotificationTemplatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminNotificationServiceAdminListNotificationTemplatesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notification-templates',
        ...options
    });
};

export const adminNotificationServiceAdminCreateNotificationTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminNotificationServiceAdminCreateNotificationTemplateData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminNotificationServiceAdminCreateNotificationTemplateResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notification-templates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminNotificationServiceAdminDeleteNotificationTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminNotificationServiceAdminDeleteNotificationTemplateData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminNotificationServiceAdminDeleteNotificationTemplateResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notification-templates/{id}',
        ...options
    });
};

export const adminNotificationServiceAdminUpdateNotificationTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminNotificationServiceAdminUpdateNotificationTemplateData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminNotificationServiceAdminUpdateNotificationTemplateResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notification-templates/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminNotificationServiceAdminRenderNotificationTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminNotificationServiceAdminRenderNotificationTemplateData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminNotificationServiceAdminRenderNotificationTemplateResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notification-templates/{id}:render',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminNotificationServiceAdminListNotificationTemplateUsages = <ThrowOnError extends boolean = false>(options: Options<AdminNotificationServiceAdminListNotificationTemplateUsagesData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminNotificationServiceAdminListNotificationTemplateUsagesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notification-templates/{id}:usages',
        ...options
    });
};

export const adminNotificationServiceAdminListNotifications = <ThrowOnError extends boolean = false>(options?: Options<AdminNotificationServiceAdminListNotificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminNotificationServiceAdminListNotificationsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/notifications',
        ...options
    });
};

export const adminOpenApiPolicyServiceGetOpenApiHardLimits = <ThrowOnError extends boolean = false>(options?: Options<AdminOpenApiPolicyServiceGetOpenApiHardLimitsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminOpenApiPolicyServiceGetOpenApiHardLimitsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/open-api/hard-limits',
        ...options
    });
};

export const adminOpenApiPolicyServiceListOpenApiPolicies = <ThrowOnError extends boolean = false>(options?: Options<AdminOpenApiPolicyServiceListOpenApiPoliciesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminOpenApiPolicyServiceListOpenApiPoliciesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/open-api/policies',
        ...options
    });
};

export const adminOpenApiPolicyServiceCreateOpenApiPolicy = <ThrowOnError extends boolean = false>(options: Options<AdminOpenApiPolicyServiceCreateOpenApiPolicyData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminOpenApiPolicyServiceCreateOpenApiPolicyResponses, unknown, ThrowOnError>({
        url: '/v2/admin/open-api/policies',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminOpenApiPolicyServiceDeleteOpenApiPolicy = <ThrowOnError extends boolean = false>(options: Options<AdminOpenApiPolicyServiceDeleteOpenApiPolicyData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminOpenApiPolicyServiceDeleteOpenApiPolicyResponses, unknown, ThrowOnError>({
        url: '/v2/admin/open-api/policies/{policy_id}',
        ...options
    });
};

export const adminOpenApiPolicyServiceGetOpenApiPolicy = <ThrowOnError extends boolean = false>(options: Options<AdminOpenApiPolicyServiceGetOpenApiPolicyData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminOpenApiPolicyServiceGetOpenApiPolicyResponses, unknown, ThrowOnError>({
        url: '/v2/admin/open-api/policies/{policy_id}',
        ...options
    });
};

export const adminOpenApiPolicyServiceUpdateOpenApiPolicy = <ThrowOnError extends boolean = false>(options: Options<AdminOpenApiPolicyServiceUpdateOpenApiPolicyData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminOpenApiPolicyServiceUpdateOpenApiPolicyResponses, unknown, ThrowOnError>({
        url: '/v2/admin/open-api/policies/{policy_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminStudioAvatarServiceListStudioConsoleAvatars = <ThrowOnError extends boolean = false>(options?: Options<AdminStudioAvatarServiceListStudioConsoleAvatarsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminStudioAvatarServiceListStudioConsoleAvatarsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/studio/avatars',
        ...options
    });
};

export const adminStudioAvatarServiceUpdateStudioConsoleAvatarLists = <ThrowOnError extends boolean = false>(options: Options<AdminStudioAvatarServiceUpdateStudioConsoleAvatarListsData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminStudioAvatarServiceUpdateStudioConsoleAvatarListsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/studio/avatars/{id}/lists',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminStudioAvatarServiceUpdateStudioConsoleAvatarTenant = <ThrowOnError extends boolean = false>(options: Options<AdminStudioAvatarServiceUpdateStudioConsoleAvatarTenantData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminStudioAvatarServiceUpdateStudioConsoleAvatarTenantResponses, unknown, ThrowOnError>({
        url: '/v2/admin/studio/avatars/{id}/tenant',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminStudioAvatarServiceDisconnectStudioConsoleAvatarUser = <ThrowOnError extends boolean = false>(options: Options<AdminStudioAvatarServiceDisconnectStudioConsoleAvatarUserData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminStudioAvatarServiceDisconnectStudioConsoleAvatarUserResponses, unknown, ThrowOnError>({
        url: '/v2/admin/studio/avatars/{id}/user',
        ...options
    });
};

export const adminStudioAvatarServiceUpdateStudioConsoleAvatarUser = <ThrowOnError extends boolean = false>(options: Options<AdminStudioAvatarServiceUpdateStudioConsoleAvatarUserData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminStudioAvatarServiceUpdateStudioConsoleAvatarUserResponses, unknown, ThrowOnError>({
        url: '/v2/admin/studio/avatars/{id}/user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Lists published announcements newest first with the caller's read state.
 */
export const announcementServiceListAnnouncements = <ThrowOnError extends boolean = false>(options?: Options<AnnouncementServiceListAnnouncementsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AnnouncementServiceListAnnouncementsResponses, unknown, ThrowOnError>({
        url: '/v2/announcements',
        ...options
    });
};

/**
 * Marks one announcement read or unread for the caller. Unread counts come
 * from InboxService.GetSummary; mark-all is InboxService.MarkAllRead.
 */
export const announcementServiceSetAnnouncementRead = <ThrowOnError extends boolean = false>(options: Options<AnnouncementServiceSetAnnouncementReadData, ThrowOnError>) => {
    return (options.client ?? client).post<AnnouncementServiceSetAnnouncementReadResponses, unknown, ThrowOnError>({
        url: '/v2/announcements/{id}:set-read',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取可购买的 Unit 套餐列表
 */
export const avatarUnitServiceListAvatarUnitPackages = <ThrowOnError extends boolean = false>(options?: Options<AvatarUnitServiceListAvatarUnitPackagesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarUnitServiceListAvatarUnitPackagesResponses, unknown, ThrowOnError>({
        url: '/v2/avatar-units/packages',
        ...options
    });
};

/**
 * 购买 Unit 套餐（Stripe Checkout）
 */
export const avatarUnitServicePurchaseAvatarUnitPackage = <ThrowOnError extends boolean = false>(options: Options<AvatarUnitServicePurchaseAvatarUnitPackageData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarUnitServicePurchaseAvatarUnitPackageResponses, unknown, ThrowOnError>({
        url: '/v2/avatar-units/packages/purchase',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取 Avatar 管线列表（含每个管线的 cost_units）
 */
export const avatarUnitServiceListAvatarPipelines = <ThrowOnError extends boolean = false>(options?: Options<AvatarUnitServiceListAvatarPipelinesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarUnitServiceListAvatarPipelinesResponses, unknown, ThrowOnError>({
        url: '/v2/avatar-units/pipelines',
        ...options
    });
};

/**
 * 获取 Unit 余额 + 未过期 grant 列表
 */
export const avatarUnitServiceGetAvatarUnitSummary = <ThrowOnError extends boolean = false>(options?: Options<AvatarUnitServiceGetAvatarUnitSummaryData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarUnitServiceGetAvatarUnitSummaryResponses, unknown, ThrowOnError>({
        url: '/v2/avatar-units/summary',
        ...options
    });
};

/**
 * 获取 Unit 流水
 */
export const avatarUnitServiceListAvatarUnitTransactions = <ThrowOnError extends boolean = false>(options?: Options<AvatarUnitServiceListAvatarUnitTransactionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarUnitServiceListAvatarUnitTransactionsResponses, unknown, ThrowOnError>({
        url: '/v2/avatar-units/transactions',
        ...options
    });
};

export const drivenIngressServiceGetAvatarInfo = <ThrowOnError extends boolean = false>(options: Options<DrivenIngressServiceGetAvatarInfoData, ThrowOnError>) => {
    return (options.client ?? client).get<DrivenIngressServiceGetAvatarInfoResponses, unknown, ThrowOnError>({
        url: '/v2/avatar/{avatarId}',
        ...options
    });
};

/**
 * 获取自动充值配置
 */
export const billingServiceGetAutoReloadConfig = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceGetAutoReloadConfigData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceGetAutoReloadConfigResponses, unknown, ThrowOnError>({
        url: '/v2/billing/auto-reload',
        ...options
    });
};

/**
 * 更新自动充值配置
 */
export const billingServiceUpdateAutoReloadConfig = <ThrowOnError extends boolean = false>(options: Options<BillingServiceUpdateAutoReloadConfigData, ThrowOnError>) => {
    return (options.client ?? client).put<BillingServiceUpdateAutoReloadConfigResponses, unknown, ThrowOnError>({
        url: '/v2/billing/auto-reload',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 设置自动充值支付方式（返回 Stripe SetupIntent client_secret）
 */
export const billingServiceSetupAutoReloadPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<BillingServiceSetupAutoReloadPaymentMethodData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceSetupAutoReloadPaymentMethodResponses, unknown, ThrowOnError>({
        url: '/v2/billing/auto-reload/setup-payment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取可用充值包列表
 */
export const billingServiceListCreditPackages = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceListCreditPackagesData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceListCreditPackagesResponses, unknown, ThrowOnError>({
        url: '/v2/billing/credit-packages',
        ...options
    });
};

/**
 * 手动购买充值包（返回 Stripe Checkout URL）
 */
export const billingServicePurchaseCreditPackage = <ThrowOnError extends boolean = false>(options: Options<BillingServicePurchaseCreditPackageData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServicePurchaseCreditPackageResponses, unknown, ThrowOnError>({
        url: '/v2/billing/credit-packages/purchase',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取 Credits 余额
 */
export const billingServiceGetCreditBalance = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceGetCreditBalanceData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceGetCreditBalanceResponses, unknown, ThrowOnError>({
        url: '/v2/billing/credits',
        ...options
    });
};

/**
 * 获取 Credits 交易记录
 */
export const billingServiceListCreditTransactions = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceListCreditTransactionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceListCreditTransactionsResponses, unknown, ThrowOnError>({
        url: '/v2/billing/credits/transactions',
        ...options
    });
};

/**
 * 获取 Stripe 客户门户链接
 */
export const billingServiceGetCustomerPortal = <ThrowOnError extends boolean = false>(options: Options<BillingServiceGetCustomerPortalData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceGetCustomerPortalResponses, unknown, ThrowOnError>({
        url: '/v2/billing/customer-portal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取可用订阅计划列表
 */
export const billingServiceListPlans = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceListPlansData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceListPlansResponses, unknown, ThrowOnError>({
        url: '/v2/billing/plans',
        ...options
    });
};

/**
 * 检查是否可以开启新 Session
 */
export const billingServiceCheckSessionPermission = <ThrowOnError extends boolean = false>(options: Options<BillingServiceCheckSessionPermissionData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceCheckSessionPermissionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/session/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取当前用户的订阅信息
 */
export const billingServiceGetSubscription = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceGetSubscriptionData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceGetSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/subscription',
        ...options
    });
};

/**
 * 创建新订阅（返回 Stripe Checkout URL）
 */
export const billingServiceCreateSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceCreateSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceCreateSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/subscription',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 取消订阅
 */
export const billingServiceCancelSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceCancelSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceCancelSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/subscription/cancel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 降级订阅计划（下个周期生效）
 */
export const billingServiceDowngradeSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceDowngradeSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceDowngradeSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/subscription/downgrade',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 恢复已取消的订阅
 */
export const billingServiceResumeSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceResumeSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceResumeSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/subscription/resume',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 升级订阅计划
 */
export const billingServiceUpgradeSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceUpgradeSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceUpgradeSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/subscription/upgrade',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取使用摘要
 */
export const billingServiceGetUsageSummary = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceGetUsageSummaryData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceGetUsageSummaryResponses, unknown, ThrowOnError>({
        url: '/v2/billing/usage',
        ...options
    });
};

export const drivenIngressServiceGetCharacterInfo = <ThrowOnError extends boolean = false>(options: Options<DrivenIngressServiceGetCharacterInfoData, ThrowOnError>) => {
    return (options.client ?? client).get<DrivenIngressServiceGetCharacterInfoResponses, unknown, ThrowOnError>({
        url: '/v2/character/{characterId}',
        ...options
    });
};

export const chatServiceListChats = <ThrowOnError extends boolean = false>(options?: Options<ChatServiceListChatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ChatServiceListChatsResponses, unknown, ThrowOnError>({
        url: '/v2/chats',
        ...options
    });
};

/**
 * Opens a new chat with its first message.
 */
export const chatServiceCreateChat = <ThrowOnError extends boolean = false>(options: Options<ChatServiceCreateChatData, ThrowOnError>) => {
    return (options.client ?? client).post<ChatServiceCreateChatResponses, unknown, ThrowOnError>({
        url: '/v2/chats',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const chatServiceSendChatMessage = <ThrowOnError extends boolean = false>(options: Options<ChatServiceSendChatMessageData, ThrowOnError>) => {
    return (options.client ?? client).post<ChatServiceSendChatMessageResponses, unknown, ThrowOnError>({
        url: '/v2/chats/{chatId}/messages',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const chatServiceGetChat = <ThrowOnError extends boolean = false>(options: Options<ChatServiceGetChatData, ThrowOnError>) => {
    return (options.client ?? client).get<ChatServiceGetChatResponses, unknown, ThrowOnError>({
        url: '/v2/chats/{id}',
        ...options
    });
};

/**
 * Closes a ticket; only tickets can be closed and a closed chat is read-only.
 */
export const chatServiceCloseChat = <ThrowOnError extends boolean = false>(options: Options<ChatServiceCloseChatData, ThrowOnError>) => {
    return (options.client ?? client).post<ChatServiceCloseChatResponses, unknown, ThrowOnError>({
        url: '/v2/chats/{id}:close',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Marks one chat read or unread for the user. Unread counts come from
 * InboxService.GetSummary; mark-all is InboxService.MarkAllRead.
 */
export const chatServiceSetChatRead = <ThrowOnError extends boolean = false>(options: Options<ChatServiceSetChatReadData, ThrowOnError>) => {
    return (options.client ?? client).post<ChatServiceSetChatReadResponses, unknown, ThrowOnError>({
        url: '/v2/chats/{id}:set-read',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * AI 素材调整（不写表，只做计算处理）
 */
export const asyncProcessingServiceAdjustMaterialAsync = <ThrowOnError extends boolean = false>(options: Options<AsyncProcessingServiceAdjustMaterialAsyncData, ThrowOnError>) => {
    return (options.client ?? client).post<AsyncProcessingServiceAdjustMaterialAsyncResponses, unknown, ThrowOnError>({
        url: '/v2/console/async-processing/adjust-material',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 创建异步任务（视频生成或重建任务，不写表，只做计算处理）
 */
export const asyncProcessingServiceCreateTaskAsync = <ThrowOnError extends boolean = false>(options: Options<AsyncProcessingServiceCreateTaskAsyncData, ThrowOnError>) => {
    return (options.client ?? client).post<AsyncProcessingServiceCreateTaskAsyncResponses, unknown, ThrowOnError>({
        url: '/v2/console/async-processing/create-task',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 列表Avatar申请
 */
export const avatarServiceListAvatarApplies = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListAvatarAppliesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarServiceListAvatarAppliesResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar-applies',
        ...options
    });
};

/**
 * 删除Avatar申请
 */
export const avatarServiceDeleteAvatarApply = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceDeleteAvatarApplyData, ThrowOnError>) => {
    return (options.client ?? client).delete<AvatarServiceDeleteAvatarApplyResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar-applies/{applyId}',
        ...options
    });
};

/**
 * 获取Avatar申请
 */
export const avatarServiceGetAvatarApply = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGetAvatarApplyData, ThrowOnError>) => {
    return (options.client ?? client).get<AvatarServiceGetAvatarApplyResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar-applies/{applyId}',
        ...options
    });
};

/**
 * 接收 Realtime 的回调
 */
export const avatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallback = <ThrowOnError extends boolean = false>(options: Options<AvatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallbackData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallbackResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar-generate-task/callback',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 预览 Avatar:上传单段 PCM16 16kHz 音频,返回对应的动画关键帧。
 * 鉴权:JWT + HasCharacterAccess 校验当前用户对 avatar 的所有权。
 * 实际的驱动 pipeline 通过内部 gRPC 转发给 driveningress 服务。
 * 创建 Studio interactive 图片预处理任务。
 * 鉴权:JWT。Console 持久化任务并负责后续编排。
 */
export const avatarServiceCreatePreprocessImage = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceCreatePreprocessImageData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceCreatePreprocessImageResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar/preprocess-images',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 查询图片预处理任务状态（精简视图，前端轮询用）。
 * 鉴权:JWT。
 */
export const avatarServiceGetPreprocessImageStatus = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGetPreprocessImageStatusData, ThrowOnError>) => {
    return (options.client ?? client).get<AvatarServiceGetPreprocessImageStatusResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar/preprocess-images/{taskId}',
        ...options
    });
};

/**
 * 获取当前用户已完成任务中已选成功候选的短期下载 URL。
 */
export const avatarServiceGetPreprocessImageCandidateDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGetPreprocessImageCandidateDownloadUrlData, ThrowOnError>) => {
    return (options.client ?? client).get<AvatarServiceGetPreprocessImageCandidateDownloadUrlResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar/preprocess-images/{taskId}/candidates/{candidateId}/download-url',
        ...options
    });
};

/**
 * 取消尚未终止的图片预处理任务。
 */
export const avatarServiceCancelPreprocessImage = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceCancelPreprocessImageData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceCancelPreprocessImageResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar/preprocess-images/{taskId}/commands/cancel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 接受检测给出的图片处理方案。
 */
export const avatarServiceConfirmPreprocessImagePlan = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceConfirmPreprocessImagePlanData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceConfirmPreprocessImagePlanResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar/preprocess-images/{taskId}/commands/confirm-plan',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 为系统错误任务创建 replacement task，不复活原任务。
 */
export const avatarServiceRetryPreprocessImageSystemError = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceRetryPreprocessImageSystemErrorData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceRetryPreprocessImageSystemErrorResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar/preprocess-images/{taskId}/commands/retry-system-error',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 选择一个已成功的候选图片。
 */
export const avatarServiceSelectPreprocessImageCandidate = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceSelectPreprocessImageCandidateData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceSelectPreprocessImageCandidateResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar/preprocess-images/{taskId}/commands/select-candidate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 列出角色
 */
export const avatarServiceListAvatars3 = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListAvatars3Data, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarServiceListAvatars3Responses, unknown, ThrowOnError>({
        url: '/v2/console/avatars',
        ...options
    });
};

/**
 * 申请创建角色
 */
export const avatarServiceCreateAvatar3 = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceCreateAvatar3Data, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceCreateAvatar3Responses, unknown, ThrowOnError>({
        url: '/v2/console/avatars',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const studioVoiceAgentServiceCreateStudioConversationSession = <ThrowOnError extends boolean = false>(options: Options<StudioVoiceAgentServiceCreateStudioConversationSessionData, ThrowOnError>) => {
    return (options.client ?? client).post<StudioVoiceAgentServiceCreateStudioConversationSessionResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatars/{avatarId}/conversation-sessions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const avatarServicePreviewAnimation = <ThrowOnError extends boolean = false>(options: Options<AvatarServicePreviewAnimationData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServicePreviewAnimationResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatars/{avatarId}/preview',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除角色
 */
export const avatarServiceDeleteAvatar2 = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceDeleteAvatar2Data, ThrowOnError>) => {
    return (options.client ?? client).delete<AvatarServiceDeleteAvatar2Responses, unknown, ThrowOnError>({
        url: '/v2/console/avatars/{id}',
        ...options
    });
};

/**
 * 获取角色详情
 */
export const avatarServiceGetAvatarDetail = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGetAvatarDetailData, ThrowOnError>) => {
    return (options.client ?? client).get<AvatarServiceGetAvatarDetailResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatars/{id}',
        ...options
    });
};

/**
 * 编辑角色
 */
export const avatarServiceUpdateAvatar2 = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceUpdateAvatar2Data, ThrowOnError>) => {
    return (options.client ?? client).patch<AvatarServiceUpdateAvatar2Responses, unknown, ThrowOnError>({
        url: '/v2/console/avatars/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 复制角色
 */
export const avatarServiceCopyAvatar2 = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceCopyAvatar2Data, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceCopyAvatar2Responses, unknown, ThrowOnError>({
        url: '/v2/console/avatars/{id}/copy',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 列出 Studio 自定义角色统一列表。
 *
 * 该接口为 /avatars/custom 提供单一分页数据源，按生成中、失败、已完成排序，
 * 并同时返回全局状态计数。旧的 /v2/console/avatars 语义保持为仅列出已完成角色。
 */
export const avatarServiceListCustomAvatars = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListCustomAvatarsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarServiceListCustomAvatarsResponses, unknown, ThrowOnError>({
        url: '/v2/console/custom-avatars',
        ...options
    });
};

/**
 * 列表 DPT 驱动 Provider
 */
export const avatarServiceListDrivenProviders = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListDrivenProvidersData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarServiceListDrivenProvidersResponses, unknown, ThrowOnError>({
        url: '/v2/console/driven-providers',
        ...options
    });
};

/**
 * 列出 kling 驱动视频
 */
export const avatarServiceListKlingMotionPresets = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListKlingMotionPresetsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarServiceListKlingMotionPresetsResponses, unknown, ThrowOnError>({
        url: '/v2/console/kling-motion-presets',
        ...options
    });
};

/**
 * Lists Studio public avatars for user-facing library pages.
 *
 * Backend filters ConsoleAvatar rows by:
 * - tenant = studio
 * - bound to ConsoleAvatarList name "public"
 * - AvatarCore status = PROD
 */
export const publicAvatarServiceListPublicAvatars = <ThrowOnError extends boolean = false>(options?: Options<PublicAvatarServiceListPublicAvatarsData, ThrowOnError>) => {
    return (options?.client ?? client).get<PublicAvatarServiceListPublicAvatarsResponses, unknown, ThrowOnError>({
        url: '/v2/console/public-avatars',
        ...options
    });
};

/**
 * 获取 R2 上传预签名 URL（用于上传文件）
 */
export const commonServiceGetR2PresignedPutUrl = <ThrowOnError extends boolean = false>(options: Options<CommonServiceGetR2PresignedPutUrlData, ThrowOnError>) => {
    return (options.client ?? client).post<CommonServiceGetR2PresignedPutUrlResponses, unknown, ThrowOnError>({
        url: '/v2/console/r2-presigned-put-url',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const studioVoiceAgentServiceListStudioVoices = <ThrowOnError extends boolean = false>(options?: Options<StudioVoiceAgentServiceListStudioVoicesData, ThrowOnError>) => {
    return (options?.client ?? client).get<StudioVoiceAgentServiceListStudioVoicesResponses, unknown, ThrowOnError>({
        url: '/v2/console/studio-voice-agent/voices',
        ...options
    });
};

/**
 * Lists notifications newest first, optionally restricted to unread items.
 */
export const inboxServiceListNotifications = <ThrowOnError extends boolean = false>(options?: Options<InboxServiceListNotificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<InboxServiceListNotificationsResponses, unknown, ThrowOnError>({
        url: '/v2/inbox/notifications',
        ...options
    });
};

/**
 * Removes one owned notification from the user's inbox.
 */
export const inboxServiceDeleteNotification = <ThrowOnError extends boolean = false>(options: Options<InboxServiceDeleteNotificationData, ThrowOnError>) => {
    return (options.client ?? client).delete<InboxServiceDeleteNotificationResponses, unknown, ThrowOnError>({
        url: '/v2/inbox/notifications/{id}',
        ...options
    });
};

/**
 * Marks one notification read or unread for the caller.
 */
export const inboxServiceSetNotificationRead = <ThrowOnError extends boolean = false>(options: Options<InboxServiceSetNotificationReadData, ThrowOnError>) => {
    return (options.client ?? client).post<InboxServiceSetNotificationReadResponses, unknown, ThrowOnError>({
        url: '/v2/inbox/notifications/{id}:set-read',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Returns the unread counters and the newest items of every section.
 */
export const inboxServiceGetSummary = <ThrowOnError extends boolean = false>(options?: Options<InboxServiceGetSummaryData, ThrowOnError>) => {
    return (options?.client ?? client).get<InboxServiceGetSummaryResponses, unknown, ThrowOnError>({
        url: '/v2/inbox/summary',
        ...options
    });
};

/**
 * Marks every item of one inbox section read for the caller.
 */
export const inboxServiceMarkAllRead = <ThrowOnError extends boolean = false>(options: Options<InboxServiceMarkAllReadData, ThrowOnError>) => {
    return (options.client ?? client).post<InboxServiceMarkAllReadResponses, unknown, ThrowOnError>({
        url: '/v2/inbox:mark-all-read',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Lists notifications newest first, optionally restricted to unread items.
 */
export const notificationServiceListNotifications = <ThrowOnError extends boolean = false>(options?: Options<NotificationServiceListNotificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<NotificationServiceListNotificationsResponses, unknown, ThrowOnError>({
        url: '/v2/notifications',
        ...options
    });
};

/**
 * Returns the authenticated user's unread notification count.
 */
export const notificationServiceGetUnreadNotificationCount = <ThrowOnError extends boolean = false>(options?: Options<NotificationServiceGetUnreadNotificationCountData, ThrowOnError>) => {
    return (options?.client ?? client).get<NotificationServiceGetUnreadNotificationCountResponses, unknown, ThrowOnError>({
        url: '/v2/notifications/unread-count',
        ...options
    });
};

/**
 * Marks one owned notification as read. Repeated calls are idempotent.
 */
export const notificationServiceMarkNotificationRead = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceMarkNotificationReadData, ThrowOnError>) => {
    return (options.client ?? client).post<NotificationServiceMarkNotificationReadResponses, unknown, ThrowOnError>({
        url: '/v2/notifications/{id}:read',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Marks every unread notification owned by the authenticated user as read.
 */
export const notificationServiceMarkAllNotificationsRead = <ThrowOnError extends boolean = false>(options: Options<NotificationServiceMarkAllNotificationsReadData, ThrowOnError>) => {
    return (options.client ?? client).post<NotificationServiceMarkAllNotificationsReadResponses, unknown, ThrowOnError>({
        url: '/v2/notifications:mark-all-read',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const drivenIngressServiceV3GetAvatarInfo = <ThrowOnError extends boolean = false>(options: Options<DrivenIngressServiceV3GetAvatarInfoData, ThrowOnError>) => {
    return (options.client ?? client).get<DrivenIngressServiceV3GetAvatarInfoResponses, unknown, ThrowOnError>({
        url: '/v3/avatar/{avatarId}',
        ...options
    });
};
